import { config } from 'env_def';
import lodashGet from 'lodash/get';
import { mailBoxOfSent, MailRecpErrMap, } from './mail_action_store_model';
import { MailContentHandler } from './mail_content_handler';
import { MailAbstractHandler, xMailerExt } from './mail_abs_handler';
import { constHttpCanceledToken } from '@/api/data/http';
import { FileSourceType } from '@/api/system/fileLoader';
import { ErrMsgCodeMap } from '@/api/errMap';
import { MailOperationHandler } from './mail_operation_handler';
import { util, wait } from '@/api/util';
import systemApi from '../../api_system/system_impl';
import { deriveCoreTrackErrorCode } from '../../../utils/coreTrackErrorCode';
import { mailPerfTool } from '@/api/util/mail_perf';
import { api } from '@/api/api';
import { apis, getUrlFinal, inWindow } from '@/config';
import { ProductAuthorityFeature } from '@/api/logical/productAuth';
import { getIn18Text } from '@/api/utils';
import { NosUploadHelper, sliceLen } from './mail_slice_upload_helper';
const MAIL_CORE_FLOW_RESULT_EVENT_ID = 'pc_mail_core_flow_result';
export class MailSendHandler extends MailOperationHandler {
    constructor(actions, modelHandler, contactHandler, mailDbHandler, subActions) {
        super(actions, modelHandler, contactHandler, mailDbHandler, subActions);
        this.attachmentInsertPos = '<i class="tmp-for-cloud-upload-replacement" style="">&nbsp;</i>';
        this.concurrentUpload = 3;
        this.useConcurrentUpload = true;
        this.lockMap = new Map();
        this.lockExpiredTIme = 20 * 60 * 1000 + 10;
        this.delLockExpiredTime = 30 * 1000 + 5;
        this.mailRecptErrMap = {
            MTA5104: '该邮箱被停用',
            MTA5106: '该邮箱无法收取邮件',
            MTA5107: '该邮箱不存在',
            MTA5103: '无发信权限，如有需要，请联系管理员',
            MTA5101: '外部邮箱，您无权限外发邮件',
            MTA5102: '企业当前为赠送域名，无法对外发信，请联系管理员更换为自有域名',
        };
        this.sequence = this.storeApi.getSeqHelper('attachment-upload', 0);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.draftApi = api.requireLogicalApi(apis.mailDraftApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.diskApi = api.requireLogicalApi(apis.netStorageImpl);
    }
    buildAttachmentReq(content, attachments, cloudattachments, operation, auto, purpose) {
        const html = content.entry.content.content;
        let attachmentHtml = '';
        const originAtta = content.entry.attachment;
        let attachmentSendStr = '';
        (Array.isArray(originAtta) ? originAtta : [originAtta]).forEach(it => {
            attachmentSendStr += JSON.stringify(it, (_, v) => {
                if (v instanceof File) {
                    return undefined;
                }
                return v;
            });
        });
        console.log('[mail-send] send attachment :', attachmentSendStr, auto);
        this.loggerApi.track('mail_attachment_will_send', {
            attachment: attachmentSendStr,
            auto,
        });
        if (!originAtta || originAtta.length === 0) {
            return;
        }
        originAtta.forEach(it => {
            if (it.type === 'url') {
                attachments.push({
                    id: it.id,
                    name: it.fileName,
                    inlined: it.inlined,
                    deleted: it.deleted,
                });
            }
            else if (it.type === 'fromInternalMail') {
                const id = (it === null || it === void 0 ? void 0 : it.fromServer) ? it.id : -1;
                if ((it.deleted === undefined || !it.deleted) && operation === 'continue' && id === -1 && it.midOfSourceMail && it.partOfSourceMail) {
                    attachments.push({
                        name: it.fileName,
                        size: it.fileSize,
                        inlined: it.inlined || false,
                        type: 'internal',
                        _mid: it.midOfSourceMail || '',
                        _part: it.partOfSourceMail || 0,
                    });
                }
                else if (id > 0 && operation === 'continue') {
                    attachments.push({
                        id,
                        inlined: it.inlined || false,
                        deleted: it.deleted || false,
                    });
                }
                else if (id > 0 && it.deleted && operation !== 'continue') {
                    attachments.push({
                        id,
                        inlined: it.inlined || false,
                        deleted: it.deleted || false,
                    });
                }
            }
            else if (it.type === 'internal' || it.type === 'upload') {
                if (it.id && it.idFilled && (it.ready || purpose === 'deleteAtt')) {
                    attachments.push({
                        id: it.id,
                        name: it.fileName,
                        inlined: it.type === 'internal',
                        deleted: it.deleted,
                    });
                }
            }
            else if (it.type === 'netfolder' || it.type === 'trs') {
                if (it.fileUrl && it.ready && !it.deleted && (operation !== 'continue' || purpose === 'generateWithCloud')) {
                    const downloadText = this.buildDownloadCardHTML(it);
                    attachmentHtml += downloadText;
                    cloudattachments.push({
                        name: it.fileName,
                        url: it.fileUrl,
                        size: it.fileSize,
                    });
                }
            }
            else if (it.type === 'netUrl') {
                const id = (it === null || it === void 0 ? void 0 : it.fromServer) ? it.id : -1;
                if ((it.deleted === undefined || !it.deleted) && operation === 'continue' && id === -1) {
                    attachments.push({
                        id,
                        name: it.fileUrl,
                        displayName: it.fileName,
                        size: it.fileSize,
                        inlined: it.inlined || false,
                        type: 'url',
                        mode: 'copy_opt',
                        deleted: it.deleted || false,
                    });
                }
                else if (id > 0 && operation === 'continue') {
                    attachments.push({
                        id,
                        inlined: it.inlined || false,
                        deleted: it.deleted || false,
                    });
                }
                else if (id > 0 && it.deleted && operation !== 'continue') {
                    attachments.push({
                        id,
                        inlined: it.inlined || false,
                        deleted: it.deleted || false,
                    });
                }
            }
        });
        if (attachmentHtml.length > 0) {
            const cloudMailTitle = getIn18Text('WANGYIQIYYXYFJ');
            attachmentHtml = `
<div id="divNeteaseSiriusCloudAttach"
     style="clear: both; margin-top: 1px; margin-bottom: 1px;font-family: verdana,Arial,Helvetica,sans-serif;
     border: 1px solid rgba(238, 238, 239, 1);box-shadow: 0px 5px 15px rgba(203, 205, 210, 0.3);border-radius: 12px;color: #262A33;"
     >
    <div style="font-size: 13px; padding: 12px 0px 12px 0px; line-height: 16px;border-bottom: 1px solid #ECECED;">
        <b style="padding-left: 12px;">${cloudMailTitle}</b>
    </div>
    ${attachmentHtml}
</div>
        `;
            content.entry.content.content = this.htmlApi.mergeHtmlStr(html, attachmentHtml);
        }
    }
    buildDownloadCardHTML(it) {
        const expiredDate = it.expired ? new Date(it.expired) : undefined;
        const fileSize = Number(it.fileSize / 1000 / 1000).toFixed(2) + 'M';
        const cloudAttaTitle = getIn18Text('YUNFUJIAN');
        const downloadT = getIn18Text('XIAZAI');
        const cloudAttaExpiredTitle = getIn18Text('GUOQISHIJIAN');
        const expiredStr = expiredDate ? util.dateFormat(expiredDate) : getIn18Text('WUQIXIAN');
        return `
     <div style="background: #fff; padding: 0px 12px;border-radius: 12px;position: relative;">
     <div style="width: 24px;position: absolute;height: 40px;left:16px;top:4px;">
     <a href="${it.fileUrl}" style="text-decoration: none;">
     <img width="24px" height="24px"
     src="https://cowork-storage-public-cdn.lx.netease.com/lxbg/2021/06/22/ca9bd44fe5cb439f99b8507c9c0d626d.png"
     border="0" title="${cloudAttaTitle}">
     </a>
     </div>
     <div style="padding-right: 32px;margin-left: 30px; border-bottom: 1px solid rgba(38, 42, 51, 0.08);margin-top: 16px;padding-bottom: 16px;">
     <div style="margin-left: 4px;">
     <div style="padding: 1px; font-size: 14px; line-height: 14px;">
     <a style=" text-decoration: none;color: #262A33;display: block" href="${it.fileUrl}"
     target="_blank"
     rel="noopener"
     download="${it.fileUrl}">
     ${it.fileName}
     </a>
     </div>
     <div style="padding: 1px;color: #262A33;opacity: 0.4;font-size: 12px;margin-top: 4px;">
     ${fileSize}&nbsp;|&nbsp;${cloudAttaExpiredTitle}：${expiredStr}
     </div>
     </div>
     </div>
     <a class="divNeteaseSiriusCloudAttachItem" href="${it.fileUrl}"
     download="${it.fileUrl}" file-name="${it.fileName}" file-size="${it.fileSize}" expired="${it.expired}" 
     file-type="${it.fileType}" file-mime="${it.fileMime}"
     id="${it.id}" file-id="${it.cloudIdentity}"
     style="text-decoration: none;display: block; font-size: 12px; line-height: 12px;position: absolute;right: 16px;top:50%;margin-top: -14px;color:#386EE7">${downloadT}</a>
     </div>
     `;
    }
    async getThumbUpInfo(mid, tid, page = 1, _account) {
        const contextUrl = this.systemApi.getUrl('getThumbUpInfo');
        const result = await this.impl
            .get(contextUrl, {
            email_mid: mid,
            email_tid: tid,
            type: 1,
            page,
            size: 20,
        }, {
            _account,
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                res = this.handleCurrentThumbOrder(res, _account);
                console.log('res.data=======', res.data);
                return res.data;
            }
            return Promise.reject(new Error('请求未成功'));
        })
            .catch(() => Promise.reject(new Error('request failed')));
        return result;
    }
    handleCurrentThumbOrder(res, _account) {
        let tmp;
        if (res.data.involvedRecords && res.data.involvedRecords.length > 0) {
            res.data.involvedRecords.forEach((record, i) => {
                if (record.acc_email === _account) {
                    tmp = record;
                    res.data.involvedRecords.splice(i, 1);
                }
            });
        }
        if (tmp) {
            res.data.involvedRecords = [tmp, ...res.data.involvedRecords];
        }
        return res;
    }
    async setThumbUpCreate(params) {
        const contextUrl = this.systemApi.getUrl('setThumbUpCreate');
        const result = await this.impl
            .post(contextUrl, params, { _account: params._account })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                res = this.handleCurrentThumbOrder(res);
                return res.data;
            }
            return Promise.reject(new Error('request failed'));
        })
            .catch(e => {
            console.warn('thumbUp error', e);
            Promise.reject(new Error('request failed'));
        });
        return result;
    }
    async getMailConfig() {
        const contextUrl = this.systemApi.getUrl('getMailConfig');
        const result = await this.impl
            .get(contextUrl, {})
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return res.data;
            }
            return Promise.reject(new Error('请求未成功'));
        })
            .catch(() => Promise.reject(new Error('getMailConfig request failed')));
        return result;
    }
    async setMailConfig(params) {
        const contextUrl = this.systemApi.getUrl('setMailConfig');
        const result = await this.impl
            .post(contextUrl, params, { contentType: 'json' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return true;
            }
            return false;
        })
            .catch(e => {
            console.warn('setMailConfig error', e);
            return false;
        });
        return result;
    }
    async getDefaultCCBCC() {
        const contextUrl = this.systemApi.getUrl('getDefaultCCBCC');
        const result = await this.impl
            .get(contextUrl, {})
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return res.data;
            }
            return Promise.reject(false);
        })
            .catch(() => Promise.reject(new Error('getDefaultCCBCC request failed')));
        return result;
    }
    async setDefaultCCBCC(params) {
        const contextUrl = this.systemApi.getUrl('setDefaultCCBCC');
        const result = await this.impl
            .post(contextUrl, params, { contentType: 'json' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return true;
            }
            return false;
        })
            .catch(e => {
            console.warn('setDefaultCCBCC error', e);
            return false;
        });
        return result;
    }
    async triggerReceive(params) {
        const contextUrl = this.systemApi.getUrl('triggerReceive');
        const reqParams = Object.assign({}, params);
        delete reqParams._account;
        const result = await this.impl
            .post(contextUrl, reqParams, { contentType: 'json', _account: params._account || '' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return true;
            }
            return false;
        })
            .catch(e => {
            console.warn('triggerReceive error', e);
            return false;
        });
        return result;
    }
    async getAuthCodeDesc() {
        const contextUrl = this.systemApi.getUrl('getAuthCodeDesc');
        const result = await this.impl
            .post(contextUrl, undefined, { contentType: 'json' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            var _a;
            if (res.code === 0) {
                return (_a = res.data) === null || _a === void 0 ? void 0 : _a.authCodeDesc;
            }
            return [];
        })
            .catch(e => {
            console.warn('triggerReceive error', e);
            return [];
        });
        return result;
    }
    async guessUserSetting(email) {
        const contextUrl = this.systemApi.getUrl('guessUserSetting');
        try {
            const result = await this.impl.post(contextUrl, { email, version: 1 }, { contentType: 'json' });
            const res = this.unpackData(result);
            if (res.code === 0 && res.data) {
                return res.data;
            }
        }
        catch (error) {
            console.error('[mail_send_handler] guessUserSetting', error);
        }
        return null;
    }
    async microsoftAuth(param) {
        const originUrl = this.systemApi.getUrl('microsoftAuth');
        let source = window.location.origin;
        if (process.env.BUILD_ISELECTRON) {
            const temp = new URL(originUrl);
            source = temp.origin || temp.host;
        }
        const reqParam = Object.assign(Object.assign({}, param), { source });
        const url = this.impl.buildUrl(originUrl, reqParam);
        try {
            const result = await this.impl.post(url, reqParam, { contentType: 'json' });
            const res = this.unpackData(result);
            if (res.code === 0 && res.data) {
                return res.data;
            }
        }
        catch (error) {
            console.error('[mail_send_handler] microsoftAuth', error);
        }
        return null;
    }
    async microsoftAuthLoop(accountPreId) {
        const originUrl = this.systemApi.getUrl('microsoftAuthLoop');
        const url = this.impl.buildUrl(originUrl, { accountPreId });
        try {
            const result = await this.impl.get(url, { accountPreId }, { contentType: 'json' });
            const res = this.unpackData(result);
            if (res.code === 0 && res.data) {
                return res.data;
            }
        }
        catch (error) {
            console.error('[mail_send_handler] microsoftAuthLoop', error);
        }
        return null;
    }
    async microsoftAuthInfo(email) {
        const originUrl = this.systemApi.getUrl('microsoftAuthInfo');
        const url = this.impl.buildUrl(originUrl, { email });
        try {
            const result = await this.impl.post(url, { email }, { contentType: 'json' });
            const res = this.unpackData(result);
            if (res.code === 0 && res.data && res.data.accountInfo) {
                return res.data.accountInfo;
            }
        }
        catch (error) {
            console.error('[mail_send_handler] microsoftAuthInfo', error);
        }
        return null;
    }
    async guidePop() {
        var _a;
        const contextUrl = this.systemApi.getUrl('guidePop');
        try {
            const res = await this.impl.post(contextUrl, {}, { contentType: 'json' });
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 0) {
                return res.data.data;
            }
        }
        catch (error) {
            console.error('[mail_send_handler] guidePop', error);
        }
        return null;
    }
    async updateDisplayEmail(params) {
        const contextUrl = this.systemApi.getUrl('updateDisplayEmail');
        const result = await this.impl
            .post(contextUrl, params, { contentType: 'json' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return res.data;
            }
        })
            .catch(e => {
            console.warn('triggerReceive error', e);
        });
        return result;
    }
    async getDisplayName(emailList) {
        const contextUrl = this.systemApi.getUrl('getDisplayName');
        const result = await this.impl
            .post(contextUrl, {
            bindEmail: emailList,
        }, { contentType: 'json' })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === 0) {
                return res.data;
            }
            return { bindUserDetail: [] };
        })
            .catch(e => {
            console.warn('triggerReceive error', e);
            return { bindUserDetail: [] };
        });
        return result;
    }
    async doDeleteAttachment(params) {
        var _a, _b, _c, _d;
        const { cid, realId, attachId, attachmentObj, _account } = params;
        const lockName = MailAbstractHandler.COMMON_DEL_ATTACHMENT_LOCK_NAME + '-' + cid;
        const deleteLock = this.storeApi.getLock(lockName, this.delLockExpiredTime, false, true);
        try {
            await deleteLock.lock();
            const element = await this.modelHandler.loadEntryFromStore(cid);
            if (!element) {
                return Promise.reject(new Error('mail not exist'));
            }
            if (!element.entry.attachment) {
                return Promise.reject(new Error('attachments not exist'));
            }
            let fileAttachModels = null;
            if (realId) {
                fileAttachModels = (_b = (_a = element.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.filter(it => (it === null || it === void 0 ? void 0 : it.realId) === realId);
            }
            if (!fileAttachModels) {
                fileAttachModels = (_d = (_c = element.entry) === null || _c === void 0 ? void 0 : _c.attachment) === null || _d === void 0 ? void 0 : _d.filter(it => (it === null || it === void 0 ? void 0 : it.id) === attachId || (it === null || it === void 0 ? void 0 : it.realId) === attachId || (it === null || it === void 0 ? void 0 : it.docId) === attachId);
            }
            const attachment = attachmentObj || (fileAttachModels ? fileAttachModels[0] : undefined);
            if (!attachment) {
                return Promise.reject(new Error('attachment not exist'));
            }
            const { fileName, fileSize } = attachment;
            const baseAttrs = { cid, fileName, fileSize, statSubKey: this.systemApi.md5(`${fileName}---${fileSize}`) };
            this.dataTrakerApi.track('mail_attachment_delete_time', Object.assign({}, baseAttrs));
            this.loggerApi.track('mail_delete_attachment', { id: element._id, attachment });
            attachment.deleted = true;
            attachment.ready = false;
            this.calculateAttachmentTotalSize(element);
            if (attachment.ready) {
                element.newUploadedAttachment && (element.newUploadedAttachment -= 1);
            }
            await this.modelHandler.saveEntryToStore(element, undefined, [attachment]);
            const continueFun = async (retry) => {
                try {
                    return this.doSaveTemp({ content: element, saveDraft: false, _account, attrObj: { id: attachment.id, purpose: 'deleteAtt' } });
                }
                catch (e) {
                    console.error('[mail add attachment]', e);
                    if (retry > 0) {
                        await wait(500);
                        return continueFun(retry - 1);
                    }
                    return Promise.reject(getIn18Text('WUFASHANCHUFUJIAN'));
                }
            };
            if (['internal', 'upload', 'url', 'netUrl', 'fromInternalMail'].includes(attachment.type)) {
                return continueFun(2)
                    .then(() => ({ success: true, code: '', title: '' }))
                    .catch(err => {
                    console.error('common attachment delete error', err);
                    const { code, title } = err;
                    this.dataTrakerApi.track('mail_attachment_delete_error', Object.assign(Object.assign({}, baseAttrs), { reason: JSON.stringify(err) }));
                    return { success: false, code: code || '', title: title || '' };
                });
            }
            if (attachment.type === 'netfolder') {
                return { success: true };
            }
            if (attachment.type === 'trs') {
                return { success: true };
            }
            const errorReason = 'not supported type ' + attachment.type;
            this.dataTrakerApi.track('mail_attachment_delete_error', Object.assign(Object.assign({}, baseAttrs), { reason: errorReason }));
            return Promise.reject(new Error(errorReason));
        }
        finally {
            try {
                deleteLock.unlock();
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    async doRenameAttachment(params) {
        var _a, _b, _c, _d, _e;
        const { cid, realId, attachId, newName, attachmentObj, _account } = params;
        const lockName = MailAbstractHandler.COMMON_DEL_ATTACHMENT_LOCK_NAME + '-' + cid;
        const deleteLock = this.storeApi.getLock(lockName, this.delLockExpiredTime, false, true);
        try {
            await deleteLock.lock();
            const element = await this.modelHandler.loadEntryFromStore(cid);
            if (!element) {
                return Promise.reject(new Error('mail not exist'));
            }
            if (!element.entry.attachment) {
                return Promise.reject(new Error('mail do not have attachment'));
            }
            let fileAttachModels = null;
            if (realId) {
                fileAttachModels = (_b = (_a = element.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.filter(it => (it === null || it === void 0 ? void 0 : it.realId) === realId);
            }
            if (!fileAttachModels) {
                fileAttachModels = (_d = (_c = element.entry) === null || _c === void 0 ? void 0 : _c.attachment) === null || _d === void 0 ? void 0 : _d.filter(it => (it === null || it === void 0 ? void 0 : it.id) === attachId || (it === null || it === void 0 ? void 0 : it.realId) === attachId || (it === null || it === void 0 ? void 0 : it.docId) === attachId);
            }
            const attachment = attachmentObj || (fileAttachModels ? fileAttachModels[0] : undefined);
            if (!attachment) {
                return Promise.reject(new Error('rename attachment not exist'));
            }
            if (attachment === null || attachment === void 0 ? void 0 : attachment.name)
                attachment.name = newName;
            if (((_e = attachment === null || attachment === void 0 ? void 0 : attachment.file) === null || _e === void 0 ? void 0 : _e.name) && (attachment === null || attachment === void 0 ? void 0 : attachment.file) instanceof File) {
                attachment.file = new File([attachment.file], newName);
            }
            if (attachment === null || attachment === void 0 ? void 0 : attachment.fileName)
                attachment.fileName = newName;
            const continueFun = async (retry) => {
                try {
                    return this.doSaveTemp({
                        content: element,
                        saveDraft: false,
                        _account,
                        attrObj: {
                            id: attachment.id,
                            purpose: 'rename',
                            attachment: Object.assign({}, attachment),
                        },
                    });
                }
                catch (e) {
                    if (retry > 0) {
                        await wait(500);
                        return continueFun(retry - 1);
                    }
                    return Promise.reject(getIn18Text('FUJIANZHONGMMSB'));
                }
            };
            if (['internal', 'upload', 'url', 'netUrl', 'fromInternalMail'].includes(attachment.type)) {
                return continueFun(2)
                    .then(async () => {
                    await this.modelHandler.saveEntryToStore(element, undefined, [attachment]);
                    return { success: true, code: '', title: '' };
                })
                    .catch(err => {
                    const { code, title } = err;
                    return { success: false, code: code || '', title: title || '' };
                });
            }
            if (['netfolder', 'trs'].includes(attachment.type)) {
                const reqRes = await this.diskApi.renameCloudAtt({
                    identity: attachment.cloudIdentity || attachment.docId || '',
                    name: newName,
                    _account,
                });
                const { success, message, code } = reqRes;
                if (success) {
                    await this.modelHandler.saveEntryToStore(element, undefined, [attachment]);
                    return { success: true };
                }
                else {
                    return { success, title: message, code };
                }
            }
            const errorReason = 'not supported type ' + attachment.type;
            return Promise.reject(new Error(errorReason));
        }
        finally {
            try {
                deleteLock.unlock();
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    doAbortAttachment(id) {
        try {
            const lock = this.lockMap.get(id);
            if (lock) {
                lock === null || lock === void 0 ? void 0 : lock.abortWaitItem(id);
                return { success: true };
            }
            return { success: false, message: getIn18Text('QUXIAOSHIBAI，ZHAOBU') };
        }
        catch (error) {
            console.log('doAbortAttachment error', error);
            return { success: false, message: getIn18Text('QUXIAOSHIBAI') };
        }
    }
    async doAddAttachment(cid, attachOrigin, flag, _account) {
        let element = await this.modelHandler.loadEntryFromStore(cid, _account);
        if (!element._id) {
            await this.doSaveTemp({ content: element, saveDraft: false, _account });
            element = await this.modelHandler.loadEntryFromStore(cid, _account);
        }
        if (!element) {
            return Promise.reject(getIn18Text('WUFAZHAODAODUIYINGYOU'));
        }
        const mailLimit = this.mailConfApi.getMailLimit({ _account });
        const total = attachOrigin.reduce((totalSize, attach) => totalSize + attach.fileSize, 0);
        if (total + (element.totalCloudAttachmentSize || 0) > MailContentHandler.MAX_ATTACHMENT_ALLOWED_SIZE) {
            this.eventApi.sendSysEvent({
                eventSeq: 0,
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'warn',
                    title: getIn18Text('DANGEYUNFUJIANDAXIAO'),
                    code: 'needCloudUpload',
                },
                auto: true,
            });
            return Promise.reject(getIn18Text('DANGEYUNFUJIANDAXIAO'));
        }
        if (!(flag === null || flag === void 0 ? void 0 : flag.usingCloud) && total + (element.totalSize || 0) > mailLimit.upload_total_size) {
            const overText = getIn18Text('PUTONGFUJIANZONGDAXIAO') + Math.floor(mailLimit.upload_total_size / 1024 / 1024) + 'M';
            const curSendVersionId = await this.productAuthApi.asyncGetProductVersionId({ _account });
            if (curSendVersionId === 'free') {
                this.eventApi.sendSysEvent({
                    eventName: 'upgradeVersion',
                    eventData: { cid },
                });
                return Promise.reject(overText);
            }
            this.eventApi.sendSysEvent({
                eventSeq: 0,
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'warn',
                    title: overText,
                    code: 'needCloudUpload',
                },
                auto: true,
            });
            return Promise.reject(overText);
        }
        let fileSizeIllegal = false;
        let illegalItem;
        const attachments = [];
        attachOrigin.forEach(it => {
            if (it.fileSize > MailContentHandler.MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE || (!(flag === null || flag === void 0 ? void 0 : flag.usingCloud) && it.fileSize > mailLimit.upload_size)) {
                fileSizeIllegal = true;
                illegalItem = it;
                return;
            }
            const attach = Object.assign({}, it);
            element.newUploadedAttachment = element.newUploadedAttachment ? element.newUploadedAttachment + 1 : 1;
            if (element.attachmentOffset === undefined) {
                element.attachmentOffset = 0;
            }
            attach.inlined = (flag === null || flag === void 0 ? void 0 : flag.inline) || false;
            attach.idFilled = true;
            attach.deleted = false;
            attach.ready = true;
            if (!attach.realId) {
                attach.realId = this.generateRndId();
            }
            attach.cloudAttachment = !!(flag === null || flag === void 0 ? void 0 : flag.usingCloud);
            attach.fileType = this.handleAttachmentType('', (attach === null || attach === void 0 ? void 0 : attach.name) || '');
            if (attach.type !== 'fromInternalMail') {
                attach.type = (flag === null || flag === void 0 ? void 0 : flag.usingCloud) ? 'trs' : 'netUrl';
            }
            attach.docId = it.id || attach.realId;
            attachments.push(attach);
            this.calculateAttachmentTotalSize(element);
        });
        if (fileSizeIllegal && illegalItem) {
            this.eventApi.sendSysEvent({
                eventSeq: 0,
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'warn',
                    title: getIn18Text('FUJIAN:') + illegalItem.fileName + getIn18Text('GUODA，WUFATIANJIA'),
                    code: 'needCloudUpload',
                },
                auto: true,
            });
            return Promise.reject(getIn18Text('FUJIAN:') + illegalItem.fileName + getIn18Text('GUODA，WUFATIANJIA'));
        }
        try {
            await this.modelHandler.saveEntryToStore(element, undefined, attachments);
            const continueFun = async (retry) => {
                try {
                    element = await this.doSaveTemp({ content: element, saveDraft: false, _account, noCheckAtt: true });
                }
                catch (e) {
                    console.error('[mail add attachment]', e);
                    if (retry > 0) {
                        await wait(500);
                        await continueFun(retry - 1);
                    }
                    else {
                        return Promise.reject(e);
                    }
                }
            };
            await continueFun(2);
            const retuRes = element.entry.attachment || [];
            retuRes.forEach(atta => {
                atta.file && delete atta.file;
            });
            return retuRes;
        }
        catch (e) {
            console.error('[mail attachment] add attachment failed', e);
            return Promise.reject('add attachment error');
        }
    }
    async attachmentUploadPreCheck(preCheckParams) {
        const { cid, element, attach, uploadWay, _account } = preCheckParams;
        if (!systemApi.isNetworkAvailable()) {
            return { success: false, reason: getIn18Text('WANGLUOYICHANG') };
        }
        if (!attach || attach.size === 0) {
            return { success: false, reason: getIn18Text('FUJIANFEIFA') };
        }
        let mailModel = null;
        if (element) {
            mailModel = element;
        }
        else if (cid) {
            mailModel = await this.modelHandler.loadEntryFromStore(cid, _account);
        }
        if (!mailModel)
            return { success: false, reason: getIn18Text('QINGCHUANRUYOUJIANmo') };
        let transformToCloud = false;
        const cloudAttConfig = this.productAuthApi.getAuthConfig(ProductAuthorityFeature.ORG_SETTING_BIG_ATTACH_SHOW);
        this.calculateAttachmentTotalSize(mailModel);
        const { totalSize } = mailModel;
        const mailLimit = this.mailConfApi.getMailLimit({ _account });
        const curSendVersionId = await this.productAuthApi.asyncGetProductVersionId({ _account });
        if (uploadWay === 'normal') {
            if (attach.size > mailLimit.upload_size) {
                const overText = getIn18Text('WENJIANGUODA，PTFJBNCG') + Math.floor(mailLimit.upload_size / 1024 / 1024) + 'M';
                if (cloudAttConfig === null || cloudAttConfig === void 0 ? void 0 : cloudAttConfig.show) {
                    transformToCloud = true;
                }
                else {
                    if (curSendVersionId === 'free') {
                        return { success: false, reason: 'free_version_attachment_size_overflow', noTrack: true };
                    }
                    return { success: false, reason: overText, noTrack: true };
                }
            }
            if (attach.size + totalSize > mailLimit.upload_total_size) {
                if (cloudAttConfig === null || cloudAttConfig === void 0 ? void 0 : cloudAttConfig.show) {
                    transformToCloud = true;
                }
                else {
                    if (curSendVersionId === 'free') {
                        return { success: false, reason: 'free_version_total_size_overflow', noTrack: true };
                    }
                    return { success: false, reason: getIn18Text('BENDEFUJIANZONGDAXIAO'), noTrack: true };
                }
            }
        }
        const uploadWayAfterCk = uploadWay === 'cloud' || transformToCloud ? 'cloud' : 'normal';
        if (uploadWayAfterCk === 'cloud') {
            const versionId = await this.productAuthApi.asyncGetProductVersionId({ _account });
            const versionSizeMap = {
                free: MailContentHandler.FREE_MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE,
                sirius: MailContentHandler.MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE,
            };
            const versionReasonMap = {
                free: '1G',
                sirius: '5G',
            };
            const sizeLimit = versionSizeMap[versionId] || MailContentHandler.OTHER_MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE;
            const reasonLimit = versionReasonMap[versionId] || '3G';
            if (attach.size > sizeLimit) {
                return { success: false, reason: getIn18Text('PUTONGYUNFUJIANDAXIAO') + reasonLimit, noTrack: true };
            }
            if (attach.size + (mailModel.totalCloudAttachmentSize || 0) > MailContentHandler.MAX_ATTACHMENT_ALLOWED_SIZE) {
                return { success: false, reason: getIn18Text('YUNFUJIANZONGDAXIAOCHAO'), noTrack: true };
            }
        }
        return { success: true, uploadWayAfterCk, transformToCloud };
    }
    trackAttachmentUploadCoreResult(params) {
        try {
            const { uploadType, result, _account, reason, code, duration, errorObj } = params;
            const actionMap = {
                inline: 'attachment_upload_inline',
                cloud: 'attachment_upload_cloud',
                normal: 'attachment_upload',
            };
            const attachmentKindMap = {
                inline: 'inline',
                cloud: 'cloud',
                normal: 'common',
            };
            const failType = result === 'fail' ? 'biz' : result === 'canceled' ? 'unknown' : undefined;
            const errorCode = deriveCoreTrackErrorCode({ result, failType, bizCode: code, reason, errorObj });
            this.dataTrakerApi.track(MAIL_CORE_FLOW_RESULT_EVENT_ID, Object.assign({ scene: 'mail_write', action: actionMap[uploadType], attachmentKind: attachmentKindMap[uploadType], result, bizCode: code, failType,
                reason,
                duration,
                _account, enableTrackInBg: true }, (errorCode !== undefined ? { errorCode } : {})));
        }
        catch (error) {
            console.log('trackAttachmentUploadCoreResult error', error);
        }
    }
    async doUploadAttachment(params) {
        var _a, _b, _c, _d, _e;
        const { cid, flag, realId } = params;
        let { attach, uploader } = params;
        const { usingCloud, inline: flagInline = false, _account } = flag || {};
        const uploadStartTime = Date.now();
        const getTrackDuration = () => Math.max(Date.now() - uploadStartTime, 0);
        let attachPath = '';
        if (typeof attach === 'string' || (typeof attach === 'object' && typeof (attach === null || attach === void 0 ? void 0 : attach.electronFullPath) === 'string')) {
            attachPath = typeof attach === 'string' ? attach : attach.electronFullPath;
            const localfile = await window.electronLib.fsManage.readFile(attachPath);
            const sep = window.electronLib.env.isMac ? '/' : '\\';
            attach = new File([localfile], attachPath.split(sep).pop());
        }
        const { name: fileName, size: fileSize } = (attach || {});
        let uploadType = flagInline ? 'inline' : usingCloud ? 'cloud' : 'normal';
        const baseAttrs = {
            cid,
            fileName,
            fileSize,
            uploadType,
        };
        const keys = {
            statKey: 'mail_attachment_upload_times',
            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}`),
        };
        let element = await this.modelHandler.loadEntryFromStore(cid, _account);
        if (!element) {
            const reason = getIn18Text('WUFAZHAODAODUIYINGYOU');
            this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason }));
            this.trackAttachmentUploadCoreResult({
                uploadType,
                result: 'fail',
                _account,
                reason,
                code: '',
                duration: getTrackDuration(),
            });
            return Promise.reject(reason);
        }
        const checkRes = await this.attachmentUploadPreCheck({ element, attach, uploadWay: usingCloud ? 'cloud' : 'normal', _account });
        const { success: checkSuc, reason: ckReason, noTrack, uploadWayAfterCk, transformToCloud } = checkRes;
        uploadType = flagInline ? 'inline' : uploadWayAfterCk === 'cloud' ? 'cloud' : 'normal';
        if (!checkSuc) {
            if (!noTrack) {
                this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason: ckReason || '' }));
            }
            this.trackAttachmentUploadCoreResult({
                uploadType,
                result: 'fail',
                _account,
                reason: ckReason || '',
                code: '',
                duration: getTrackDuration(),
            });
            return Promise.reject(ckReason || '');
        }
        if (uploader) {
            uploader = Object.assign(Object.assign({}, uploader), { noErrorMsgEmit: true, _account });
        }
        else {
            uploader = {
                noErrorMsgEmit: true,
                _account,
            };
        }
        if (!element._id) {
            if (flag === null || flag === void 0 ? void 0 : flag._account) {
                await this.doSaveTemp({ content: Object.assign(Object.assign({}, element), { _account: flag._account }), saveDraft: false, _account });
            }
            else {
                await this.doSaveTemp({ content: element, saveDraft: false, _account });
            }
            element = await this.modelHandler.loadEntryFromStore(cid, _account);
        }
        if (!Array.isArray((_a = element === null || element === void 0 ? void 0 : element.entry) === null || _a === void 0 ? void 0 : _a.attachment)) {
            element.entry.attachment = [];
        }
        const fileSourceKey = this.systemApi.md5(attach.name, true) + '|' + attach.size + '|' + attach.lastModified;
        const recordType = uploadWayAfterCk === 'cloud' ? 'cloud' : 'common';
        const fileType = this.handleAttachmentType(attach.type, attach.name);
        const attachItem = {
            realId: realId || this.generateRndId(),
            id: -1,
            fileSize: attach.size,
            fileMime: attach.type,
            fileType,
            file: attach,
            fileName: attach.name,
            type: !flagInline ? (uploadWayAfterCk === 'cloud' ? 'netfolder' : 'upload') : 'internal',
            deleted: false,
            ready: false,
            idFilled: false,
            fileSourceKey,
            fileSourceType: FileSourceType.uploadMail,
        };
        element.newUploadedAttachment = element.newUploadedAttachment ? element.newUploadedAttachment + 1 : 1;
        const toRecord = !flagInline;
        if (toRecord) {
            mailPerfTool.attachmentTransfer('upload', recordType, 'start');
        }
        if (element.attachmentOffset === undefined) {
            element.attachmentOffset = 0;
        }
        if (transformToCloud) {
            this.eventApi.sendSysEvent({
                eventName: 'attachToCloud',
                eventData: {
                    attachItem,
                },
            });
        }
        try {
            this.performanceApi.time(Object.assign(Object.assign({}, keys), { params: Object.assign({}, baseAttrs) }));
            const res = await this.uploadInternalCallLock(element, attachItem, uploader);
            try {
                this.performanceApi.timeEnd(Object.assign(Object.assign({}, keys), { params: Object.assign(Object.assign({}, baseAttrs), { uploadSize: fileSize - ((res === null || res === void 0 ? void 0 : res.originOffset) || 0) }) }));
            }
            catch (error) {
                console.log('mail_attachment_upload_times error', error);
            }
            res.attachPath = attachPath;
            if (toRecord) {
                mailPerfTool.attachmentTransfer('upload', recordType, 'end', {
                    result: 'success',
                    fileSize: attach.size,
                    fileType,
                });
            }
            const retuRes = Object.assign({}, res);
            retuRes.file && delete retuRes.file;
            this.trackAttachmentUploadCoreResult({
                uploadType,
                result: 'success',
                _account,
                code: 'S_OK',
                duration: getTrackDuration(),
            });
            return retuRes;
        }
        catch (e) {
            const trackReason = typeof e === 'string' ? e : (e === null || e === void 0 ? void 0 : e.title) || (e === null || e === void 0 ? void 0 : e.message) || '上传失败';
            const trackCode = typeof (e === null || e === void 0 ? void 0 : e.code) === 'string' || typeof (e === null || e === void 0 ? void 0 : e.code) === 'number' ? String(e.code) : '';
            if (e === 'free_version_attachment_size_overflow') {
                this.trackAttachmentUploadCoreResult({
                    uploadType,
                    result: 'fail',
                    _account,
                    reason: e,
                    code: e,
                    duration: getTrackDuration(),
                    errorObj: e,
                });
                return Promise.reject(e);
            }
            if (e === 'free_version_attachment_total_size_overflow') {
                this.trackAttachmentUploadCoreResult({
                    uploadType,
                    result: 'fail',
                    _account,
                    reason: e,
                    code: e,
                    duration: getTrackDuration(),
                    errorObj: e,
                });
                return Promise.reject(e);
            }
            if (toRecord) {
                mailPerfTool.attachmentTransfer('upload', recordType, 'end', {
                    result: ((_b = e) === null || _b === void 0 ? void 0 : _b.code) === 'user.cancel' ? 'cancel' : 'fail',
                    fileSize: attach.size,
                    fileType,
                });
            }
            if (((_c = e) === null || _c === void 0 ? void 0 : _c.code) === 'user.cancel' || e === '用户取消' || ((e === null || e === void 0 ? void 0 : e.name) === 'Error' && (e === null || e === void 0 ? void 0 : e.message) === '用户取消')) {
                this.trackAttachmentUploadCoreResult({
                    uploadType,
                    result: 'canceled',
                    _account,
                    reason: '用户取消',
                    code: 'user.cancel',
                    duration: getTrackDuration(),
                    errorObj: e,
                });
                return Promise.reject('用户取消');
            }
            if ((e === null || e === void 0 ? void 0 : e.name) === 'Error' && (e === null || e === void 0 ? void 0 : e.message)) {
                this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason: e.message || '上传失败', code: '' }));
            }
            if (typeof e === 'string') {
                this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason: e || '上传失败', code: '' }));
            }
            if (e === null || e === void 0 ? void 0 : e.title) {
                this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason: (e === null || e === void 0 ? void 0 : e.title) || '上传失败', code: e.code || '' }));
            }
            try {
                this.dataTrakerApi.track('mail_attachment_upload_error', Object.assign(Object.assign({}, baseAttrs), { reason: JSON.stringify(e), code: e === null || e === void 0 ? void 0 : e.code }));
            }
            catch (error) {
                console.log('统一打点失败', error);
            }
            if ((e === null || e === void 0 ? void 0 : e.title) === 'A requested file or directory could not be found at the time an operation was processed.') {
                this.trackAttachmentUploadCoreResult({
                    uploadType,
                    result: 'fail',
                    _account,
                    reason: trackReason,
                    code: trackCode,
                    duration: getTrackDuration(),
                    errorObj: e,
                });
                return Promise.reject(getIn18Text('SHANGCHUANSHIBAI，FUJIAN'));
            }
            this.trackAttachmentUploadCoreResult({
                uploadType,
                result: 'fail',
                _account,
                reason: trackReason,
                code: trackCode,
                duration: getTrackDuration(),
                errorObj: e,
            });
            if (this.impl.isAxiosResponse(e)) {
                const code = (_d = e.data) === null || _d === void 0 ? void 0 : _d.code;
                if (code && ErrMsgCodeMap[code]) {
                    return Promise.reject(ErrMsgCodeMap[code]);
                }
                if ((_e = e.data) === null || _e === void 0 ? void 0 : _e.message) {
                    return Promise.reject(e.data.message);
                }
            }
            return Promise.reject(getIn18Text('SHANGCHUANFUJIANCHUXIANCUO'));
        }
    }
    getLockName(elementId, attachItemType) {
        const lockName = MailAbstractHandler.COMMON_ATTACHMENT_LOCK_NAME + '-' + elementId + '-' + (attachItemType === 'netfolder' ? 0 : 1);
        return lockName;
    }
    async uploadInternalCallLock(element, attachItem, uploader) {
        const { realId, type: attachItemType } = attachItem;
        const lockName = this.getLockName(element._id, attachItemType);
        const uploadLock = this.storeApi.getLock(lockName, this.lockExpiredTIme, false, true);
        const lockEventId = realId ? realId + '' : '';
        this.lockMap.set(lockEventId, uploadLock);
        await uploadLock.lock(lockEventId);
        const res = await this.uploadInternalCall(element, attachItem, uploader, uploadLock, lockEventId);
        return res;
    }
    async uploadInternalCall(element, attachItem, uploader, uploadLock, lockEventId) {
        console.log('uploadInternalCall', element);
        const { _account } = uploader || {};
        attachItem.fileSourceKey = `${attachItem.fileSourceKey};${element._id}`;
        const checkRes = await this.attachmentUploadPreCheck({
            cid: element === null || element === void 0 ? void 0 : element.cid,
            attach: attachItem === null || attachItem === void 0 ? void 0 : attachItem.file,
            uploadWay: attachItem.type === 'netfolder' ? 'cloud' : 'normal',
            _account,
        });
        const { success: checkSuc, reason: ckReason, uploadWayAfterCk, transformToCloud } = checkRes;
        if (!checkSuc) {
            uploadLock === null || uploadLock === void 0 ? void 0 : uploadLock.unlock();
            this.lockMap.delete(lockEventId);
            return Promise.reject(ckReason || '');
        }
        if (transformToCloud) {
            this.eventApi.sendSysEvent({
                eventName: 'attachToCloud',
                eventData: {
                    attachItem,
                },
            });
        }
        if (attachItem.type !== 'internal') {
            attachItem.type = uploadWayAfterCk === 'cloud' ? 'netfolder' : 'upload';
        }
        if (attachItem.type === 'internal' || uploadWayAfterCk === 'normal') {
            try {
                await this.uploadAttachment(element, attachItem, uploader);
                return attachItem;
            }
            catch (e) {
                if (typeof e === 'object' && e && e.code === 'storedLockTimeout') {
                    this.markUploadFailed(attachItem);
                    await this.doSaveCancelUploadResult(element, attachItem, true);
                    this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                        size: attachItem.fileSize,
                        reason: 'exception:' + (e && e.code ? e.code : ''),
                    });
                }
                throw e;
            }
            finally {
                uploadLock === null || uploadLock === void 0 ? void 0 : uploadLock.unlock();
                this.lockMap.delete(lockEventId);
            }
        }
        else {
            try {
                if (this.useConcurrentUpload) {
                    await this.uploadAttachmentLegacy2(element, attachItem, uploader);
                }
                else {
                    await this.uploadAttachmentLegacy(element, attachItem, uploader);
                }
                return attachItem;
            }
            catch (e) {
                if (typeof e === 'object' && e && e.code === 'storedLockTimeout') {
                    this.markUploadFailed(attachItem);
                    await this.doSaveCancelUploadResult(element, attachItem, true);
                    this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                        size: attachItem.fileSize,
                        reason: 'exception:' + (e && e.code ? e.code : ''),
                    });
                }
                throw e;
            }
            finally {
                uploadLock === null || uploadLock === void 0 ? void 0 : uploadLock.unlock();
                this.lockMap.delete(lockEventId);
            }
        }
    }
    async uploadAttachmentLegacy(content, item, uploader) {
        if (!content._id)
            throw new Error('call saveTemp first');
        if (!content.entry || !content.entry.attachment || !item)
            throw new Error('no attachment found');
        if (!item.file)
            throw new Error('no attachment file set');
        let canceled = false;
        const attachment = item;
        const { fileSize: attFileSize } = attachment;
        const { _account } = uploader || {};
        let cloudUploaderCommonArgs = {
            fileId: 0,
            nosKey: '',
            token: '',
            offset: 0,
            context: '',
        };
        const qrPromise = this.impl.get(this.systemApi.getUrl('uploadAttachmentLegacyToken'), {
            fileName: item.fileName,
            fileSize: item.fileSize,
            md5: item.fileMd5 || this.systemApi.md5(item.fileName),
        }, {
            cachePolicy: 'noCache',
            contentType: 'form',
            responseType: 'text',
            expectedResponseType: 'json',
            _account,
        });
        let time;
        return qrPromise
            .then(this.unpackData.bind(this))
            .then(async (qrRs) => {
            if ((qrRs.code === 'FA_COMPOSE_NOT_FOUND' || qrRs.code === 'FA_ID_NOT_FOUND') && inWindow() && !window.isAccountBg) {
                this.eventApi.sendSysEvent({
                    eventName: 'mailStoreRefresh',
                    eventStrData: 'resetMailWithDraft',
                    eventData: { cid: content.cid },
                });
            }
            if (!qrRs || !qrRs.data || qrRs.code !== 0)
                return this.handleUploadLegencyError(qrRs);
            const { new: new1, context, bucketName, nosKey, fileId, token, uploadHost } = qrRs.data;
            cloudUploaderCommonArgs = Object.assign(Object.assign({}, cloudUploaderCommonArgs), { fileId,
                nosKey,
                token,
                context });
            attachment.idFilled = true;
            attachment.id = fileId;
            const uploadHostStr = uploadHost || MailSendHandler.mailAttachmentUploadHost;
            const uploadHostUrl = uploadHostStr.endsWith('/') ? uploadHostStr : uploadHostStr + '/';
            const uploadUrl = `${uploadHostUrl}${bucketName}/${nosKey}`;
            await this.modelHandler.saveEntryToStore(content, undefined, [attachment]).then();
            if (new1 === false && context) {
                const offsetUrl = `${uploadHostUrl}${bucketName}/${nosKey}?uploadContext&context=${context}&version=1.0`;
                const offsetRes = await this.impl.get(offsetUrl, {}, {
                    headers: { 'x-nos-token': token },
                    _account,
                });
                const { status, data: offsetData } = offsetRes;
                if (status === 200 && offsetData) {
                    const { offset } = offsetData;
                    cloudUploaderCommonArgs = Object.assign(Object.assign({}, cloudUploaderCommonArgs), { offset });
                    uploader = this.buildAttachmentSliceUploader(uploader, item, { offset }, qrRs.data);
                    return this.uploadFile(uploadUrl, attachment, uploader, true);
                }
                throw new Error('[mail-send] getUploadContext failed');
            }
            this.calculateAttachmentTotalSize(content);
            uploader = this.buildAttachmentSliceUploader(uploader, item, { offset: 0 }, qrRs.data);
            uploader.firstUploadAction = data => {
                const { context: pieceContext } = data;
                this.modifyContext({
                    context: pieceContext,
                    fileId,
                    nosKey,
                    fileSize: attFileSize,
                }, _account);
            };
            time = Date.now();
            return this.uploadFile(uploadUrl, attachment, uploader, true);
        })
            .then(res => {
            canceled = !!res.config.canceled;
            return res;
        })
            .then((res) => {
            console.log('[mail-send] uploadAttachmentLegacy result for cloud ', res, canceled);
            console.error(`[mlzou-test] 串行上传消耗：${util.useTime(time)}`);
            if (res && res.status === 200 && !canceled) {
                return this.impl
                    .post(this.systemApi.getUrl('uploadAttachmentLegacyFinished'), {
                    fileId: cloudUploaderCommonArgs.fileId,
                    nosKey: cloudUploaderCommonArgs.nosKey,
                    fileSize: attachment.fileSize,
                }, { _account })
                    .then((res) => {
                    attachment.uploadOffset = uploader ? uploader.offset : 0;
                    attachment.uploadContext = uploader ? uploader.context : '';
                    if (res.data && res.data.data && res.status === 200) {
                        if (res.data.data.identity) {
                            attachment.cloudIdentity = String(res.data.data.identity || '');
                        }
                        attachment.expired = res.data.data.expireTime;
                        attachment.ready = true;
                        attachment.deleted = false;
                        attachment.filePreviewUrl = res.data.data.downloadUrl ? '' : undefined;
                        attachment.fileUrl = res.data.data.downloadUrl;
                        return this.modelHandler.saveEntryToStore(content, undefined, [attachment]).then(() => content);
                    }
                    return this.uploadAttachmentLegacyFail(attachment, content, uploader, res);
                })
                    .catch(() => this.uploadAttachmentLegacyFail(attachment, content, uploader, res));
            }
            return this.uploadAttachmentLegacyFail(attachment, content, uploader, res);
        })
            .catch(reason => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            this.markUploadFailed(attachment);
            attachment.uploadOffset = uploader ? uploader.offset : 0;
            attachment.uploadContext = uploader ? uploader.context : '';
            const exist = Array.isArray(content.entry.attachment) ? content.entry.attachment.find(v => v.id === attachment.id) : null;
            if (!exist) {
                content.entry.attachment.push(attachment);
            }
            console.log('[mail-send] uploadAttachmentLegacy failed:', reason, typeof reason, attachment);
            if ((_a = reason === null || reason === void 0 ? void 0 : reason.data) === null || _a === void 0 ? void 0 : _a.message) {
                this.doSaveCancelUploadResult(content, attachment);
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'info',
                        title: (_b = reason === null || reason === void 0 ? void 0 : reason.data) === null || _b === void 0 ? void 0 : _b.message,
                        content: '',
                        code: 'PARAM.ERR',
                    },
                    eventSeq: 0,
                });
                return Promise.reject({
                    title: `${(_c = reason === null || reason === void 0 ? void 0 : reason.data) === null || _c === void 0 ? void 0 : _c.message}`,
                    code: 'user.cancel',
                });
            }
            if ((_e = (_d = reason === null || reason === void 0 ? void 0 : reason.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) {
                this.doSaveCancelUploadResult(content, attachment);
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'info',
                        title: (_g = (_f = reason === null || reason === void 0 ? void 0 : reason.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message,
                        content: '',
                        code: 'PARAM.ERR',
                    },
                    eventSeq: 0,
                });
                return Promise.reject({
                    title: `${(_j = (_h = reason === null || reason === void 0 ? void 0 : reason.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.message}`,
                    code: 'user.cancel',
                });
            }
            if ((_k = reason === null || reason === void 0 ? void 0 : reason.data) === null || _k === void 0 ? void 0 : _k.errMsg) {
                this.doSaveCancelUploadResult(content, attachment, true);
                return Promise.reject({
                    title: `${(_l = reason === null || reason === void 0 ? void 0 : reason.data) === null || _l === void 0 ? void 0 : _l.errMsg}`,
                    code: ((_m = reason === null || reason === void 0 ? void 0 : reason.data) === null || _m === void 0 ? void 0 : _m.errCode) || '',
                });
            }
            if ((reason === null || reason === void 0 ? void 0 : reason.message) && typeof reason.message === 'string' && reason.message.startsWith(constHttpCanceledToken)) {
                this.doSaveCancelUploadResult(content, attachment);
                this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                    size: attachment.fileSize,
                    reason: 'userCancel',
                });
                return Promise.reject({
                    title: '用户取消',
                    code: 'user.cancel',
                });
            }
            this.doSaveCancelUploadResult(content, attachment, true);
            this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                size: attachment.fileSize,
                reason: 'exception:' + (reason && reason.code ? reason.code : ''),
            });
            return Promise.reject(this.commonCatch(reason));
        });
    }
    async uploadAttachmentLegacy2(content, item, uploader) {
        if (!content._id)
            throw new Error('call saveTemp first');
        if (!content.entry || !content.entry.attachment || !item)
            throw new Error('no attachment found');
        if (!item.file)
            throw new Error('no attachment file set');
        const attachment = item;
        const { _account, progressIndicator, operatorSet } = uploader || {};
        const qrPromise = this.impl.get(this.systemApi.getUrl('uploadAttachmentLegacyToken'), {
            fileName: item.fileName,
            fileSize: item.fileSize,
            md5: item.fileMd5 || this.systemApi.md5(item.fileName),
        }, {
            cachePolicy: 'noCache',
            contentType: 'form',
            responseType: 'text',
            expectedResponseType: 'json',
            _account,
        });
        const qrRs = await qrPromise.then(this.unpackData.bind(this));
        if ((qrRs.code === 'FA_COMPOSE_NOT_FOUND' || qrRs.code === 'FA_ID_NOT_FOUND') && inWindow() && !window.isAccountBg) {
            this.eventApi.sendSysEvent({
                eventName: 'mailStoreRefresh',
                eventStrData: 'resetMailWithDraft',
                eventData: { cid: content.cid },
            });
        }
        if (!qrRs || !qrRs.data || qrRs.code !== 0)
            return this.handleUploadLegencyError(qrRs);
        const { bucketName, nosKey, fileId, token } = qrRs.data;
        attachment.idFilled = true;
        attachment.id = fileId;
        await this.modelHandler.saveEntryToStore(content, undefined, [attachment]).then();
        if (!attachment.file) {
            throw new Error('参数错误，上传的文件不存在');
        }
        const time = Date.now();
        try {
            await this.doConcurrentUpload({
                nosConfig: {
                    objectKey: nosKey,
                    bucketName,
                    token,
                },
                file: item.file,
                progressIndicator,
                operatorSet,
            });
            console.error(`[mlzou-test] 并行上传消耗：${util.useTime(time)}`);
            const newAttachment = await this.handleUploadAttachmentLegacyFinished(nosKey, attachment, _account);
            await this.modelHandler.saveEntryToStore(content, undefined, [newAttachment]);
            return content;
        }
        catch (error) {
            this.markUploadFailed(attachment);
            this.doSaveCancelUploadResult(content, attachment);
            let errorInfo;
            let reason;
            if ((error === null || error === void 0 ? void 0 : error.from) === 'concurrentUploadCancel') {
                errorInfo = {
                    title: '用户取消',
                    code: 'user.cancel',
                };
                reason = 'userCancel';
            }
            else if ((error === null || error === void 0 ? void 0 : error.from) === 'concurrentUploadException') {
                errorInfo = {
                    title: error.msg,
                    code: error.code,
                };
                reason = 'concurrentUploadError';
            }
            else if ((error === null || error === void 0 ? void 0 : error.from) === 'uploadFinishedFailed') {
                errorInfo = {
                    title: '上传失败，请稍后尝试',
                    code: 'uploadFinished.failed',
                };
                reason = 'uploadFinishedError';
            }
            else {
                errorInfo = this.commonCatch(error);
                reason = 'exception:' + (error && error.code ? error.code : '');
            }
            this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                size: attachment.fileSize,
                reason,
            });
            return Promise.reject(errorInfo);
        }
    }
    async handleUploadAttachmentLegacyFinished(nosKey, attachment, _account) {
        try {
            const url = this.systemApi.getUrl('uploadAttachmentLegacyFinished');
            const res = await this.impl.post(url, {
                nosKey,
                fileId: attachment.id,
                fileSize: attachment.fileSize,
            }, { _account });
            if (res.data && res.data.data && res.status === 200) {
                if (res.data.data.identity) {
                    attachment.cloudIdentity = String(res.data.data.identity || '');
                }
                attachment.expired = res.data.data.expireTime;
                attachment.ready = true;
                attachment.deleted = false;
                attachment.filePreviewUrl = res.data.data.downloadUrl ? '' : undefined;
                attachment.fileUrl = res.data.data.downloadUrl;
            }
            return attachment;
        }
        catch (error) {
            return Promise.reject({
                from: 'uploadFinishedFailed',
                message: error === null || error === void 0 ? void 0 : error.message,
                code: error === null || error === void 0 ? void 0 : error.code,
            });
        }
    }
    doConcurrentUpload(params) {
        const { progressIndicator, operatorSet, nosConfig, file } = params;
        return new Promise((reslove, reject) => {
            const uploader = new NosUploadHelper('concurrent');
            const task = uploader.upload({
                nosConfig,
                file,
                complete: data => {
                    reslove(data);
                },
                error: (msg, code) => {
                    reject({ msg, code, from: 'concurrentUploadException' });
                },
                progress: data => {
                    if (progressIndicator && data) {
                        progressIndicator(data.percent, data.sent);
                    }
                },
            });
            if (operatorSet) {
                operatorSet(action => {
                    if (action === 'abort') {
                        if (!task._destroyed) {
                            task.destroy();
                        }
                        reject({
                            from: 'concurrentUploadCancel',
                        });
                    }
                    else if (action === 'pause') {
                        task.pause();
                    }
                    else if (action === 'resume') {
                        if (task.paused) {
                            task.upload();
                        }
                    }
                });
            }
        });
    }
    async modifyContext(params, _account) {
        const { context, fileId, nosKey, fileSize } = params;
        const modUploadContextUrl = this.systemApi.getUrl('modifyUploadContext');
        const res = await this.impl.post(modUploadContextUrl, {
            context,
            fileId,
            nosKey,
            fileSize,
        }, { _account });
        return res;
    }
    handleUploadLegencyError(qrRs) {
        var _a;
        return Promise.reject(this.getErrMsg(qrRs.code) || ((_a = qrRs.ret) === null || _a === void 0 ? void 0 : _a.message) || '上传失败，请稍后尝试');
    }
    async uploadAttachmentLegacyFail(attachment, content, uploader, res) {
        this.markUploadFailed(attachment);
        const current = Array.isArray(content.entry.attachment) ? content.entry.attachment.find(v => v.id === attachment.id) : null;
        if (current) {
            current.uploadOffset = uploader ? uploader.offset : 0;
            current.uploadContext = uploader ? uploader.context : '';
            this.doSaveCancelUploadResult(content, current, true);
            await this.modelHandler.saveEntryToStore(content, undefined, [current]);
        }
        else {
            attachment.uploadOffset = uploader ? uploader.offset : 0;
            attachment.uploadContext = uploader ? uploader.context : '';
            content.entry.attachment.push(attachment);
            this.doSaveCancelUploadResult(content, attachment, true);
            await this.modelHandler.saveEntryToStore(content, undefined, [attachment]);
        }
        return this.handleUploadLegencyError(res);
    }
    buildAttachmentSliceUploader(uploader, item, cloudUploaderCommonArgs, qrs) {
        if (!uploader) {
            throw new Error('参数有误');
        }
        const pu = uploader;
        pu.headers = {
            'x-nos-token': qrs.token,
        };
        pu.responseType = 'text';
        pu.contentType = 'stream';
        pu.expectedResponseType = 'json';
        pu.sliceSize = sliceLen;
        pu.offset = cloudUploaderCommonArgs.offset || 0;
        pu.status = 'start';
        pu.token = qrs.token;
        pu.context = item.idFilled ? qrs.context : '';
        pu.nextUploader = res => {
            var _a;
            const canceled = !!res.config.canceled;
            if (canceled) {
                return undefined;
            }
            if (res.data && +res.status === 200) {
                const isComplete = pu.offset >= item.file.size;
                if (isComplete) {
                    return undefined;
                }
                pu.offset = res.data.offset || 0;
                pu.context = res.data.context || '';
                const data = res.data;
                item.id = ((_a = data.ret) === null || _a === void 0 ? void 0 : _a.fid) || item.id;
                if (data.var && data.var.exist) {
                    return undefined;
                }
                pu.offset = data.offset;
                return pu;
            }
            return undefined;
        };
        return pu;
    }
    async uploadAttachment(content, item, uploader, retry) {
        console.log('[mail-send][upload mail attachment uploadAttachment]', content, item, retry);
        if (!content._id) {
            throw new Error('call saveTemp first');
        }
        if (!content.entry || !content.entry.attachment || !item) {
            throw new Error('no attachment found');
        }
        const attachment = item;
        const { _account } = uploader || {};
        if (!attachment.file) {
            throw new Error('no attachment file set');
        }
        const key = 'uploadPrepare';
        const additionalParam = _account ? this.getAccountSession(_account) : undefined;
        const preUrl = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session));
        const req = {
            attachmentId: attachment.id,
            composeId: content._id || '',
            contentType: attachment.fileMime || '',
            fileName: attachment.fileName,
            offset: content.attachmentOffset || 0,
            size: attachment.fileSize,
        };
        const conf = this.getConfigForHttp(key, {
            data: req,
            url: preUrl,
            contentType: 'json',
            _account,
        });
        console.log('uploadAttachment getConfigForHttp', conf, _account, additionalParam);
        const result = await this.impl.post(preUrl, req, conf);
        this.loggerApi.track('upload_attachment_prepare_result', { attachmentId: attachment.id, retry, result });
        const res = this.unpackData(result);
        if (retry)
            return res;
        this.loggerApi.track('upload_attachment_prepare_afterretry_res', { attachmentId: attachment.id, retry, res });
        if ((res.code === 'FA_COMPOSE_NOT_FOUND' || res.code === 'FA_ID_NOT_FOUND') && inWindow() && !window.isAccountBg) {
            this.loggerApi.track('upload_attachment_fail', { trigger: 'resetMailWithDraftStart', content: JSON.stringify(content) });
            this.eventApi.sendSysEvent({
                eventName: 'mailStoreRefresh',
                eventStrData: 'resetMailWithDraft',
                eventData: { cid: content.cid },
            });
            return Promise.reject(res.code);
        }
        const curSendVersionId = await this.productAuthApi.asyncGetProductVersionId({ _account });
        if (curSendVersionId === 'free') {
            if (res.code === 'FA_OVERFLOW' && res.overflowReason === 'pref_smtp_max_send_mail_size') {
                return Promise.reject('free_version_total_size_overflow');
            }
            if (res.code === 'FA_UPLOAD_SIZE_EXCEEDED') {
                return Promise.reject('free_version_attachment_size_overflow');
            }
        }
        const handleRes = async (res) => {
            var _a, _b;
            if (res.code === MailContentHandler.sOk) {
                attachment.idFilled = !!((_a = res === null || res === void 0 ? void 0 : res.var) === null || _a === void 0 ? void 0 : _a.attachmentId);
                attachment.id = ((_b = res === null || res === void 0 ? void 0 : res.var) === null || _b === void 0 ? void 0 : _b.attachmentId) || attachment.id;
                this.calculateAttachmentTotalSize(content);
                await this.modelHandler.saveEntryToStore(content, undefined, [attachment]);
                return this.callUploadApi(uploader, attachment, content);
            }
            this.markUploadFailed(attachment);
            return Promise.reject(this.getErrMsg(res.code));
        };
        return handleRes(res);
    }
    callUploadApi(uploader, attachment, content) {
        console.log('[mail-send][upload mail attachment callUploadApi]', content);
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const { _account } = uploader || {};
        let additionalParam = {
            composeId: content._id || '',
            attachmentId: attachment.id + '',
            offset: isCorpMail ? '0' : String(content.attachmentOffset || 0),
        };
        if (_account) {
            additionalParam = Object.assign(Object.assign({}, this.getAccountSession(_account)), additionalParam);
        }
        console.log('callUploadApi additionalParam', additionalParam);
        const url = this.buildUrl('upload', additionalParam, !!additionalParam._session, _account);
        let canceled = false;
        let agentNode = null;
        return this.uploadFile(url, attachment, uploader)
            .then(res => {
            const { config } = res;
            canceled = !!res.config.canceled;
            agentNode = config.agentNode || null;
            return res;
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            var _a, _b, _c, _d, _e;
            if (res.code === MailContentHandler.sOk) {
                attachment.id = ((_a = res.var) === null || _a === void 0 ? void 0 : _a.attachmentId) || attachment.id;
                attachment.contentId = (_b = res.var) === null || _b === void 0 ? void 0 : _b.composeId;
                if (!canceled) {
                    attachment.ready = true;
                    attachment.deleted = false;
                    content._account = content._account || _account;
                    attachment.fileUrl = this.buildUploadedAttachmentDownloadUrl(content, attachment.id, undefined, _account ? this.systemApi.getSessionNameOfSubAccount(_account) : '', agentNode);
                    content.entry.attachment = (_c = content.entry.attachment) === null || _c === void 0 ? void 0 : _c.map(item => {
                        if (item.realId === attachment.realId)
                            return attachment;
                        return item;
                    });
                    this.calculateAttachmentTotalSize(content);
                    return this.doSaveTemp({ content, saveDraft: false, _account, attrObj: { id: attachment.id, attachment, purpose: 'addAtt' } })
                        .then(() => this.modelHandler.saveEntryToStore(content, undefined, [attachment]))
                        .then(() => content);
                }
                this.markUploadFailed(attachment);
                content.entry.attachment = (_d = content.entry.attachment) === null || _d === void 0 ? void 0 : _d.map(item => {
                    if (item.realId === attachment.realId)
                        return attachment;
                    return item;
                });
                return this.doSaveCancelUploadResult(content, attachment).then(() => content);
            }
            this.markUploadFailed(attachment);
            content.entry.attachment = (_e = content.entry.attachment) === null || _e === void 0 ? void 0 : _e.map(item => {
                if (item.realId === attachment.realId)
                    return attachment;
                return item;
            });
            return Promise.reject(this.getErrMsg(res.code));
        })
            .catch(async (reason) => {
            var _a;
            this.markUploadFailed(attachment);
            content.entry.attachment = (_a = content.entry.attachment) === null || _a === void 0 ? void 0 : _a.map(item => {
                if (item.realId === attachment.realId)
                    return attachment;
                return item;
            });
            console.log('[mail-send] upload failed:', reason, typeof reason, attachment, content.cid);
            if (reason && reason.message && typeof reason.message === 'string' && reason.message.startsWith(constHttpCanceledToken)) {
                await this.doSaveCancelUploadResult(content, attachment);
                this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                    size: attachment.fileSize,
                    reason: 'userCancel',
                });
                return Promise.reject({
                    title: '用户取消',
                    code: 'user.cancel',
                });
            }
            if (content.cid && attachment.idFilled) {
                try {
                    await this.doDeleteAttachment({ cid: content.cid, realId: attachment.realId, attachId: attachment.id, attachmentObj: undefined, _account });
                }
                catch (error) {
                    console.log('上传删除失败', error);
                }
            }
            this.dataTrakerApi.track('occur_mailAttachmentUpload_Failed', {
                size: attachment.fileSize,
                reason: 'exception:' + (reason && reason.code ? reason.code : ''),
            });
            return Promise.reject(this.commonCatch(reason));
        });
    }
    uploadFile(url, content, uploader, byPiece) {
        return byPiece ? this.fileApi.uploadPieceByPiece(url, content, uploader) : this.fileApi.upload(url, content, uploader);
    }
    async doSaveCancelUploadResult(content, attachment, noDelete) {
        if (content.cid && attachment.idFilled && attachment.id && !noDelete) {
            try {
                await this.doDeleteAttachment({ cid: content.cid, realId: attachment.realId, attachId: attachment.id, attachmentObj: undefined, _account: content._account });
            }
            catch (error) {
                console.warn('doSaveCancelUploadResult error', error);
            }
        }
        else {
            if (content.newUploadedAttachment !== undefined && content.newUploadedAttachment > 0) {
                content.newUploadedAttachment -= 1;
            }
            else {
                content.newUploadedAttachment = 0;
            }
            this.calculateAttachmentTotalSize(content);
        }
    }
    markUploadFailed(attachment) {
        attachment.ready = false;
        attachment.deleted = true;
    }
    buildUploadedAttachmentDownloadUrl(content, attachId, cloudAdditional, _session, agentNode) {
        const { _account } = content;
        if (!cloudAdditional) {
            let sessionId = '';
            if (_account) {
                const result = this.getAccountSession(_account);
                _session = _session || result._session;
                sessionId = result.sid;
            }
            else {
                const currentUser = this.systemApi.getCurrentUser(_account);
                if (!currentUser) {
                    return '';
                }
                sessionId = currentUser.sessionId;
            }
            if (_session) {
                const preUrl = this.buildUrl('downloadTmpAttachment', Object.assign({
                    sid: sessionId || '',
                    composeId: content._id || '',
                    attachId: attachId + '',
                }, { _session }), undefined, _account);
                return getUrlFinal(preUrl, agentNode || 'hz');
            }
            return this.buildUrl('downloadTmpAttachment', Object.assign({
                sid: sessionId || '',
                composeId: content._id || '',
                attachId: attachId + '',
            }), undefined, _account);
        }
        return this.impl.buildUrl('http://fs.qiye.163.com/fs/display/', {
            p: 'X-NETEASE-HUGE-ATTACHMENT',
            file: cloudAdditional.url,
            title: cloudAdditional.fileName,
            _account,
        });
    }
    calculateAttachmentTotalSize(element) {
        if (element.entry.attachment && element.entry.attachment.length > 0) {
            let ret = 0;
            let clRet = 0;
            let offset = 0;
            element.entry.attachment.forEach(it => {
                if (it.idFilled && !it.deleted) {
                    if (it.type === 'netfolder' || it.type === 'trs') {
                        clRet += it.fileSize;
                    }
                    else if (it.type === 'internal' || it.type === 'upload' || it.type === 'netUrl' || it.type === 'fromInternalMail') {
                        ret += it.fileSize;
                    }
                    if (it.ready) {
                        offset += it.fileSize;
                    }
                }
                else if (it.type === 'url') {
                    ret += it.fileSize || 0;
                }
            });
            element.totalSize = ret;
            element.totalCloudAttachmentSize = clRet;
            element.attachmentOffset = offset;
            return ret;
        }
        return 0;
    }
    async doCancelCompose(cid, deleteDraft, _account) {
        if (!cid) {
            return Promise.resolve('param wrong');
        }
        const entryFromStore = await this.modelHandler.loadEntryFromStore(cid, _account);
        if (entryFromStore && entryFromStore._id) {
            const additionalParam = entryFromStore._account ? this.getAccountSession(entryFromStore._account) : undefined;
            const key = 'cancelCompose';
            const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session));
            const data = {
                ids: [entryFromStore._id],
                deleteDraft,
            };
            return this.impl
                .post(url, data, this.getConfigForHttp(key, { url, data, _account }))
                .then(this.unpackData.bind(this))
                .then(res => {
                if (res.code === MailContentHandler.sOk) {
                    this.modelHandler.clearEntryFromStore(cid, entryFromStore._id, _account);
                    return '';
                }
                const errMsg = this.getErrMsg(res.code);
                errMsg.popupType = 'ignore';
                return Promise.reject(errMsg);
            });
        }
        return Promise.resolve('not exist');
    }
    doFastSend(content) {
        return this.initModel(content).then((res) => this.doSendMail(res));
    }
    filterAttachments(arr) {
        const res = [];
        for (const file of arr) {
            const hasRepeat = res === null || res === void 0 ? void 0 : res.some(f => f.displayName === file.displayName && f.size === file.size && f.type === file.type);
            if (!hasRepeat) {
                res.push(file);
            }
        }
        return res;
    }
    async doSaveDraftLocal(content) {
        const { cid, _account } = content;
        if (!cid)
            return;
        if (_account && _account !== this.systemApi.getMainAccount1().email)
            return;
        try {
            const draftVersionId = `${cid}-${new Date().getTime()}`;
            content = this.modelHandler.unFreezeObject(content);
            content.entry.content.content = this.modelHandler.delImgFailedUpload(content.entry.content.content);
            const contentClone = Object.assign(Object.assign({}, content), { draftVersionId });
            await this.modelHandler.mergeStoreUnfinishedMail(contentClone, true);
        }
        catch (error) {
            console.log('存草稿入本地失败', error);
        }
    }
    async doSaveTemp(params) {
        var _a;
        const { saveDraft, auto, attrObj, _account, callPurpose, noCheckAtt } = params;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (auto && targetActions && saveDraft && Date.now() - targetActions.lastSaveTmpTimestamp < 5 * 1000) {
            return Promise.reject(new Error('存草稿过于频繁'));
        }
        let { content: _content } = params;
        let deleteLock;
        try {
            if (saveDraft) {
                const lockName = MailAbstractHandler.COMMON_DEL_ATTACHMENT_LOCK_NAME + '-' + _content.cid;
                deleteLock = this.storeApi.getLock(lockName, this.delLockExpiredTime, false, true);
                await deleteLock.lock();
            }
            _content = this.modelHandler.unFreezeObject(_content);
            _content.entry.content.content = this.modelHandler.delImgFailedUpload(_content.entry.content.content);
            let contenttmp = this.modelHandler.syncAndUpdateLocalContentInMemory(_content);
            if (!contenttmp) {
                contenttmp = await this.modelHandler.syncAndUpdateLocalContent(_content);
            }
            else {
                this.modelHandler.saveEntryToStore(contenttmp).then();
            }
            const content = contenttmp;
            const key = 'postMail';
            let additionalParam = saveDraft ? MailContentHandler.composeUrlParam.save : undefined;
            if (content._account) {
                additionalParam = Object.assign(Object.assign({}, this.getAccountSession(content._account)), (saveDraft ? MailContentHandler.composeUrlParam.save : {}));
            }
            const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session));
            const operation = saveDraft ? 'save' : 'continue';
            const purpose = callPurpose || (attrObj === null || attrObj === void 0 ? void 0 : attrObj.purpose) || '';
            const req = this.buildMailSendRequest({ content, operation, auto, purpose, attrObj, noCheckAtt });
            content.entry.sendStatus = 'sending';
            console.log('[mail-send] save tmp mail:', url, req);
            return this.impl
                .post(url, req, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data: req, url })), { _account: content._account }))
                .then(this.unpackData.bind(this))
                .then(async (res) => {
                var _a, _b, _c;
                const re = res;
                if (res.code === MailContentHandler.sOk) {
                    if (re.draftId) {
                        content.draftId = re.draftId;
                        content.newUploadedAttachment = 0;
                    }
                    content._id = typeof (re === null || re === void 0 ? void 0 : re.var) === 'string' ? res === null || res === void 0 ? void 0 : res.var : (_a = res === null || res === void 0 ? void 0 : res.var) === null || _a === void 0 ? void 0 : _a.id;
                    if (typeof res.var !== 'string') {
                        const reponseMailModel = res === null || res === void 0 ? void 0 : res.var;
                        const _attachments = reponseMailModel.attachments;
                        if (callPurpose === 'sendCheck') {
                            const checkPass = this.doMailAttachmentCheckFull(_attachments, content);
                            content.checkPass = checkPass;
                            return content;
                        }
                        content.entry.attachment = (_b = content.entry.attachment) === null || _b === void 0 ? void 0 : _b.map(it => this.handleAttachmentFromServer(it, _attachments));
                    }
                    content.entry.sendStatus = 'saved';
                    if (saveDraft && auto && targetActions)
                        targetActions.lastSaveTmpTimestamp = Date.now();
                    return this.modelHandler.saveEntryToStore(content).then(() => content);
                }
                if (content) {
                    try {
                        const attSize = (_c = content.entry.attachment) === null || _c === void 0 ? void 0 : _c.filter(file => file.inlined).reduce((prev, next) => prev + (next.fileSize || 0), 0);
                        this.dataTrackApi.track('pc_mail_send_error', {
                            mailSize: content.totalSize,
                            attSize,
                            msg: re.message || re.msgCodeDesc || '',
                            composeId: content.cid,
                            code: re.code,
                            _account,
                        });
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
                content.entry.sendStatus = 'sentFailed';
                return this.modelHandler.saveEntryToStore(content).then(() => Promise.reject(res.code));
            })
                .catch(ex => {
                content.entry.sendStatus = 'sentFailed';
                if (ex === 'FA_COMPOSE_NOT_FOUND' || ex === 'FA_ID_NOT_FOUND') {
                    return Promise.reject(ex);
                }
                return this.modelHandler.saveEntryToStore(content).then(() => Promise.reject(auto ? 'failed' : this.commonCatch(ex)));
            })
                .finally(() => {
                const { cid, draftId, _account } = content;
                if (cid && content.entry.sendStatus !== 'sentFailed') {
                    if (saveDraft) {
                        if (_account && _account !== this.systemApi.getMainAccount1().email)
                            return;
                        const draftVersionId = `${cid}-${new Date().getTime()}`;
                        const contentClone = Object.assign(Object.assign({}, content), { draftVersionId });
                        this.modelHandler.saveEntryToUnfinishedMail(contentClone, true).then(() => (draftId ? this.modelHandler.coverDraft(cid, draftId) : Promise.resolve()));
                    }
                }
            });
        }
        finally {
            if (saveDraft) {
                try {
                    deleteLock && deleteLock.unlock();
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    async doGenerateNewMail(params) {
        const { content, generateAccount, withCloudAtt, latestedCont } = params;
        const key = 'postMail';
        content._account = generateAccount;
        if (latestedCont)
            content.entry.content.content = latestedCont;
        const additionalParam = this.getAccountSession(generateAccount || '');
        const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session));
        const req = this.buildMailSendRequest({ content, operation: 'continue', purpose: withCloudAtt ? 'generateWithCloud' : '' });
        content.entry.sendStatus = 'sending';
        return this.impl
            .post(url, req, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data: req, url })), { _account: generateAccount }))
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            var _a;
            const re = res;
            if (res.code === MailContentHandler.sOk) {
                content._id = typeof (re === null || re === void 0 ? void 0 : re.var) === 'string' ? res === null || res === void 0 ? void 0 : res.var : (_a = res === null || res === void 0 ? void 0 : res.var) === null || _a === void 0 ? void 0 : _a.id;
                content.entry.sendStatus = 'saved';
                return content;
            }
            return Promise.reject(res.code);
        })
            .catch(ex => {
            content.entry.sendStatus = 'sentFailed';
            return Promise.reject(this.commonCatch(ex));
        });
    }
    async doGetLatestedDraftId(params) {
        const { content, oldCid } = params;
        const key = 'postMail';
        let additionalParam = MailContentHandler.composeUrlParam.save;
        if (content._account) {
            additionalParam = Object.assign(Object.assign({}, this.getAccountSession(content._account)), MailContentHandler.composeUrlParam.save);
        }
        const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session));
        const oldContent = await this.modelHandler.loadEntryFromStore(oldCid);
        content.entry.attachment = (oldContent.entry.attachment || []).filter(att => att.cloudAttachment === true || att.type === 'netfolder');
        const req = this.buildMailSendRequest({ content, operation: 'save', auto: true, purpose: 'forcesave' });
        return this.impl
            .post(url, req, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data: req, url })), { _account: content._account }))
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            const re = res;
            if (res.code === MailContentHandler.sOk) {
                if (re.draftId) {
                    return re.draftId;
                }
                return Promise.reject('获取草稿id失败');
            }
            return Promise.reject('获取草稿id失败');
        })
            .catch(ex => {
            console.log('doGetLatestedDraftId error', ex);
            return Promise.reject('获取草稿id失败');
        });
    }
    handleAttachmentFromServer(item, _attachments) {
        const target = _attachments === null || _attachments === void 0 ? void 0 : _attachments.find(({ name }) => name === item.fileUrl);
        if (target) {
            return Object.assign(Object.assign({}, item), { id: target.id, fromServer: true });
        }
        const ntarget = _attachments === null || _attachments === void 0 ? void 0 : _attachments.find(({ id }) => id === item.id);
        if (ntarget) {
            return Object.assign(Object.assign({}, item), { serverDel: ntarget.deleted, fromServer: true });
        }
        const mtarget = _attachments === null || _attachments === void 0 ? void 0 : _attachments.find(({ _mid, _part }) => _mid === item.midOfSourceMail && _part === String(item.partOfSourceMail));
        if (mtarget) {
            return Object.assign(Object.assign({}, item), { id: mtarget.id, serverDel: mtarget.deleted, fromServer: true });
        }
        return item;
    }
    async doCheckSendMailContent(_con) {
        let contenttmp = this.modelHandler.syncAndUpdateLocalContentInMemory(_con);
        try {
            if (!contenttmp) {
                contenttmp = await this.modelHandler.syncAndUpdateLocalContent(_con);
            }
            else {
                this.modelHandler.saveEntryToStore(contenttmp).then();
            }
        }
        catch (e) {
            console.error('check mail send error ', e);
            return { checkResult: false, content: _con };
        }
        const con = contenttmp;
        this.loggerApi.track('do_send_mail_send_check_before', {
            cid: con.cid,
            _id_before: con._id || '',
            _id_input: _con._id || '',
        });
        let result;
        try {
            result = await this.doSaveTemp({ content: con, saveDraft: false, auto: false, _account: con._account, callPurpose: 'sendCheck' });
        }
        catch (e) {
            return { checkResult: false, content: con, errCode: e };
        }
        this.loggerApi.track('do_send_mail_send_check_after', {
            cid: con.cid,
            _id_after: con._id || '',
            checkPass: (result === null || result === void 0 ? void 0 : result.checkPass) || false,
        });
        const checkResult = (result === null || result === void 0 ? void 0 : result.checkPass) || false;
        if (checkResult) {
            return { checkResult, content: con };
        }
        return { checkResult, content: con, errCode: 'MAIL_STATUS_ERROR' };
    }
    async reSend(content, isSubAccount, isConference) {
        const { _account } = content;
        if (isConference) {
            return { content, icsReupload: true };
        }
        isSubAccount && this.dataTrakerApi.track('pcMail_switchSender_writeMailPage_agent', { attachmentReload: 2, _account });
        return { content, attReupload: true };
    }
    async doReSendInitMail(cid, resendAccount, withCloudAtt, latestedCont) {
        const content = await this.modelHandler.loadEntryFromStore(cid);
        const generateAccount = resendAccount || '';
        if (withCloudAtt) {
            content.entry.attachment = (content.entry.attachment || []).filter(att => att.cloudAttachment === true || att.type === 'netfolder');
        }
        else {
            content.entry.attachment = [];
        }
        delete content._id;
        content._account = generateAccount;
        try {
            content.resend = true;
            const newContent = await this.doGenerateNewMail({ content, generateAccount, withCloudAtt, latestedCont });
            newContent.resend = false;
            newContent.cid = this.sequence.nextOne(generateAccount);
            delete newContent.draftId;
            delete newContent.mailFormClickWriteMail;
            await this.modelHandler.saveEntryToStore(newContent);
            return newContent;
        }
        catch (e) {
            return Promise.reject(new Error('resend fail'));
        }
    }
    async doGetExcludeAttIds(cid, latestedCont) {
        const content = await this.modelHandler.loadEntryFromStore(cid);
        if (latestedCont)
            content.entry.content.content = latestedCont;
        let excludInineAtt = [];
        try {
            if (content.entry.attachment && content.entry.attachment.length > 0) {
                const conf = new Map([['mailModel', content]]);
                content.entry.content.content = this.modelHandler.getTransferHtml(content.entry.content, 'sendMail', true, conf);
                content.entry.attachment.forEach(it => {
                    if (it.id && (it.inlined || it.type === 'internal')) {
                        if (!conf.get('img-' + it.id)) {
                            excludInineAtt = [...excludInineAtt, it.id + ''];
                        }
                    }
                });
            }
            return excludInineAtt;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async doTransferAtts(params) {
        console.log('doTransferAtts', params);
        const key = 'transferAttachment';
        const url = this.systemApi.getUrl(key);
        const data = params;
        return this.impl
            .post(url, data, { contentType: 'json', timeout: 30 * 60 * 1000 })
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            if ((res === null || res === void 0 ? void 0 : res.success) && res.data) {
                return res.data;
            }
            return Promise.reject(res.message || '重传失败');
        })
            .catch(reason => Promise.reject(this.commonCatch(reason)));
    }
    doSendMail(con) {
        var _a;
        let content;
        const { _account, conference } = con;
        const isSubAccount = ((_a = con === null || con === void 0 ? void 0 : con.optSender) === null || _a === void 0 ? void 0 : _a.isSubAccount) || false;
        this.loggerApi.track('do_send_mail_enter', {
            cid: con.cid,
            _id: con._id || '',
            _account,
        });
        return this.doCheckSendMailContent(con)
            .then(async (res) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            console.log('doCheckSendMailContent', res);
            const { checkResult, errCode } = res;
            let { content } = res;
            if (errCode === 'FA_COMPOSE_NOT_FOUND' || errCode === 'FA_ID_NOT_FOUND') {
                try {
                    const reSendRes = await this.reSend(content, isSubAccount, !!conference);
                    content = reSendRes.content;
                    if (reSendRes.attReupload) {
                        let needUploadAtt = false;
                        if (((_b = (_a = reSendRes === null || reSendRes === void 0 ? void 0 : reSendRes.content) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.attachment) && ((_e = (_d = (_c = reSendRes === null || reSendRes === void 0 ? void 0 : reSendRes.content) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.attachment) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                            if (!((_h = (_g = (_f = reSendRes === null || reSendRes === void 0 ? void 0 : reSendRes.content) === null || _f === void 0 ? void 0 : _f.entry) === null || _g === void 0 ? void 0 : _g.attachment) === null || _h === void 0 ? void 0 : _h.every(item => item.deleted === true))) {
                                needUploadAtt = true;
                            }
                        }
                        if (!needUploadAtt) {
                            return Promise.reject('FA_MTA_RETRY_SILENT');
                        }
                        return Promise.reject('FA_MTA_RETRY');
                    }
                    if (reSendRes.icsReupload) {
                        return Promise.reject('FA_MTA_ICSRETRY');
                    }
                    return content;
                }
                catch (e) {
                    return Promise.reject(errCode);
                }
            }
            if (errCode === 'MAIL_STATUS_ERROR') {
                return Promise.reject('MAIL_STATUS_ERROR');
            }
            if (!errCode) {
                isSubAccount && this.dataTrackApi.track('pcMail_switchSender_writeMailPage_agent', { attachmentReload: 0, _account });
            }
            if (!checkResult) {
                this.loggerApi.track('write_letter_request_doSendMail_error1', { res });
                const failedAttachment = (_j = con.entry.attachment) === null || _j === void 0 ? void 0 : _j.filter(it => it.mailCheckResult && !it.mailCheckResult.pass);
                const names = failedAttachment && failedAttachment.length > 0 ? failedAttachment.reduce((pre, item) => pre + '  ' + item.name, getIn18Text('FUJIAN')) : undefined;
                if (names) {
                    this.eventApi.sendSysEvent({
                        eventSeq: 0,
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'window',
                            popupLevel: 'error',
                            title: getIn18Text('TISHI'),
                            content: names + getIn18Text('WEISHANGCHUANWANCHENG，QING'),
                            code: 'attachment_upload_uncompleted',
                        },
                    });
                    return Promise.reject(new Error('mail check failed'));
                }
            }
            return content;
        })
            .then(async (newCon) => {
            var _a;
            content = newCon;
            const key = 'postMail';
            content.praiseLetter = con.praiseLetter;
            content.task = con.task;
            let url;
            if (con.praiseLetter) {
                url = this.buildPriaseUrl(key, MailContentHandler.composeUrlParam.deliver, con._account);
            }
            else if (con.includeVariable) {
                url = this.buildVariableEmailUrl(key, MailContentHandler.composeUrlParam.deliver, con._account);
            }
            else if (con.isDyncGroupSend) {
                url = this.buildDyncGroupSendMailUrl(key, MailContentHandler.composeUrlParam.deliver, con._account);
            }
            else if (content.task) {
                url = this.buildCreateTaskUrl(key, Object.assign({}, MailContentHandler.composeUrlParam.deliver), con._account);
            }
            else {
                let additionalParam = MailContentHandler.composeUrlParam.deliver;
                if (con._account) {
                    additionalParam = Object.assign(Object.assign({}, this.getAccountSession(con._account)), MailContentHandler.composeUrlParam.deliver);
                }
                if (content.setEncrypt) {
                    additionalParam = Object.assign(Object.assign({}, additionalParam), { encrypt: '1', cl_send: '2' });
                }
                url = this.buildUrl(key, additionalParam, !!additionalParam._session, _account);
            }
            let req = this.buildMailSendRequest({
                content,
                operation: content.scheduleDate ? 'schedule' : 'deliver',
                auto: undefined,
                purpose: undefined,
                pureText: (_a = con.status) === null || _a === void 0 ? void 0 : _a.puretext,
            });
            if (con.entry.linkAttached) {
                req.flagLinkAttached = true;
            }
            console.log('[mail-send] send mail:', req);
            this.loggerApi.track('write_letter_request', { req });
            content.entry.sendStatus = 'sending';
            content.entry.folder = mailBoxOfSent.id;
            const currentNode = this.storeApi.getCurrentNode(_account);
            const headers = {
                'MAIL-SERVER-LOCATION': currentNode,
                'MAIL-SERVER-TYPE': 'QIYE_MAIL',
            };
            if (con.isDyncGroupSend) {
                req = {
                    req: req,
                    contactVariables: con.contactVariables,
                };
            }
            return this.impl.post(url, req, Object.assign(Object.assign({}, this.getConfigForHttp(key, {
                url,
                data: req,
                headers,
                timeout: 90 * 1000,
            })), { _account: con._account }));
        })
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            var _a, _b, _c, _d, _e, _f;
            try {
                const cloneRes = JSON.parse(JSON.stringify(res));
                if ((_a = cloneRes === null || cloneRes === void 0 ? void 0 : cloneRes.var) === null || _a === void 0 ? void 0 : _a.content) {
                    cloneRes.var.content = cloneRes.var.content.match(/<img.*?>/g);
                }
                this.loggerApi.track('write_letter_response', { cloneRes });
            }
            catch (error) {
                this.loggerApi.track('write_letter_response_tryerror', { error });
            }
            if (!content) {
                return Promise.reject(new Error('unknown error ,content is undefined'));
            }
            const re = res;
            if (res.code === MailContentHandler.sOk) {
                if (re.savedSent && re.savedSent.mid) {
                    content.id = re.savedSent.mid;
                }
                content._id = ((_b = res === null || res === void 0 ? void 0 : res.var) === null || _b === void 0 ? void 0 : _b.id) || (res === null || res === void 0 ? void 0 : res.var);
                content.entry.sendStatus = 'sent';
                content.errMsg = undefined;
                content.entry.tid = res.tid;
                (_c = content.entry.attachment) === null || _c === void 0 ? void 0 : _c.forEach(attachment => {
                    attachment.file && delete attachment.file;
                });
                content.sentTInfo = re.sentTInfo;
                if (con.includeVariable && res.data.vmail) {
                    content.composeId = res.data.vcomposeId;
                }
                if (con.isDyncGroupSend && res.data.vmail) {
                    content.composeId = res.data.vcomposeId;
                }
                try {
                    this.doGetMailContent(content.id, { noCache: true, _account: content._account || '' });
                }
                catch (error) {
                    console.log('doGetMailContent error', error);
                }
                return content;
            }
            if (re.code === 'FA_COMPOSE_NOT_FOUND' || re.code === 'FA_ID_NOT_FOUND') {
                try {
                    const reSendRes = await this.reSend(Object.assign(Object.assign({}, content), { conference: con.conference }), isSubAccount, !!conference);
                    content = reSendRes.content;
                    if (reSendRes.attReupload) {
                        if (!((_e = (_d = reSendRes === null || reSendRes === void 0 ? void 0 : reSendRes.content) === null || _d === void 0 ? void 0 : _d.entry) === null || _e === void 0 ? void 0 : _e.attachment) || reSendRes.content.entry.attachment.length === 0) {
                            return Promise.reject('FA_MTA_RETRY_SILENT');
                        }
                        return Promise.reject('FA_MTA_RETRY');
                    }
                    if (reSendRes.icsReupload) {
                        return Promise.reject('FA_MTA_ICSRETRY');
                    }
                    return content;
                }
                catch (e) {
                    return Promise.reject(re.code);
                }
            }
            if (re.code === 'FA_MTA_REJECTED' && re.mtaCode === 5912) {
                return Promise.reject(Object.assign(Object.assign({}, re), { simpleIntro: 'needRiskAuth' }));
            }
            content.entry.sendStatus = 'sentFailed';
            const msgItem = this.buildSendMailErr(Object.assign(Object.assign({}, re), { receiver: (content === null || content === void 0 ? void 0 : content.receiver) || [] }));
            if (msgItem) {
                content.errMsg = {
                    code: re.code,
                    msg: ErrMsgCodeMap[re.code],
                    msgItem,
                };
                return content;
            }
            if (content) {
                try {
                    const attSize = (_f = content.entry.attachment) === null || _f === void 0 ? void 0 : _f.filter(file => file.inlined).reduce((prev, next) => prev + (next.fileSize || 0), 0);
                    this.dataTrackApi.track('pc_mail_save_error', {
                        mailSize: content.totalSize,
                        attSize,
                        msg: re.message || re.msgCodeDesc || '',
                        composeId: content.cid,
                        code: re.code,
                        _account,
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
            return Promise.reject(this.commonCatch(`${re.code}${re.mtaCode || ''}`, re.message || re.msgCodeDesc || '', {
                account: con._account || '',
                overflowReason: re.overflowReason,
            }));
        })
            .catch(async (reason) => {
            content && (content.entry.sendStatus = content.entry.sendStatus || 'sentNetworkFailed');
            if (reason === 'FA_MTA_RETRY' || reason === 'FA_MTA_RETRY_SILENT' || reason === 'FA_MTA_ICSRETRY') {
                return Promise.reject(reason);
            }
            if ((reason === null || reason === void 0 ? void 0 : reason.simpleIntro) === 'needRiskAuth') {
                return Promise.reject(reason);
            }
            let curSendVersionId = '';
            try {
                curSendVersionId = await this.productAuthApi.asyncGetProductVersionId({ _account: _account || '' });
            }
            catch (error) {
                console.log('asyncGetProductVersionId error', error);
            }
            if (curSendVersionId === 'free') {
                if (reason === 'FA_OVERFLOW' && reason.overflowReason === 'pref_smtp_max_send_mail_size') {
                    return Promise.reject('free_version_total_size_overflow');
                }
                if (reason === 'FA_UPLOAD_SIZE_EXCEEDED') {
                    return Promise.reject('free_version_attachment_size_overflow');
                }
            }
            if (reason === 'MAIL_STATUS_ERROR') {
                return Promise.reject(reason);
            }
            if (reason === 'FA_MTA_REJECTED552' || (reason === null || reason === void 0 ? void 0 : reason.code) === 'FA_MTA_REJECTED552') {
                return Promise.reject(reason);
            }
            if (reason === 'ERR.SUBACCOUNT.EXPIRED') {
                return Promise.reject(reason);
            }
            if (content === null || content === void 0 ? void 0 : content.cid) {
                this.modelHandler.saveEntryToStore(content);
            }
            return Promise.reject(this.commonCatch(reason));
        });
    }
    async doCancelDeliver(params) {
        const { _account } = params;
        const key = 'cancelDeliver';
        const url = this.buildUrl(key, { action: 'cancelDeliver' }, undefined, _account);
        const data = params;
        return this.impl
            .post(url, data, this.getConfigForHttp(key, { data, url, _account }))
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            const { code, message } = res;
            if (code === MailContentHandler.sOk) {
                return { success: true };
            }
            return Promise.reject(this.commonCatch(code, message || ''));
        })
            .catch(reason => Promise.reject(this.commonCatch(reason)));
    }
    async doImmediateDeliver(params) {
        const { _account } = params;
        const key = 'immediateDeliver';
        const url = this.buildUrl(key, { action: 'immediateDeliver' }, undefined, _account);
        const data = params;
        return this.impl
            .post(url, data, this.getConfigForHttp(key, { data, url, _account }))
            .then(this.unpackData.bind(this))
            .then(async (res) => {
            const { code, message } = res;
            if (code === MailContentHandler.sOk) {
                return { success: true };
            }
            return Promise.reject(this.commonCatch(code, message || ''));
        })
            .catch(reason => Promise.reject(this.commonCatch(reason)));
    }
    buildSendmailErrorForCorp(res) {
        var _a;
        const result = [];
        if (res.code === 'FA_MTA_RCPT_ERROR') {
            const errorRepts = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.errorRcpts) || {};
            Object.keys(errorRepts).forEach((email) => {
                const errorCode = errorRepts[email];
                const errorMsg = this.mailRecptErrMap[errorCode];
                if (errorCode && errorMsg) {
                    result.push({
                        code: errorCode,
                        email,
                        reason: errorMsg,
                    });
                }
            });
        }
        return result && result.length ? result : undefined;
    }
    buildSendMailErr(res) {
        const { receiver } = res;
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            return this.buildSendmailErrorForCorp(res);
        }
        if (res.errorRcpts && typeof res.errorRcpts === 'object') {
            const ret = [];
            if (res && res.errorRcpts && typeof res.errorRcpts === 'object') {
                Object.keys(res.errorRcpts).forEach(it => {
                    const errorRcptsKey = it;
                    const arr = res.errorRcpts;
                    if (res.errorRcpts && errorRcptsKey && Object.prototype.hasOwnProperty.apply(res.errorRcpts, [errorRcptsKey]) && arr[errorRcptsKey]) {
                        const item = arr[errorRcptsKey];
                        item.forEach(it => {
                            ret.push({
                                code: errorRcptsKey,
                                email: it,
                                reason: MailRecpErrMap[errorRcptsKey],
                            });
                        });
                    }
                });
            }
            return ret;
        }
        if (typeof res.errorRcpts === 'string') {
            let emailArr = [];
            if (receiver && res.code !== 'FA_MTA_ACCESS_DENIED') {
                receiver.forEach(item => {
                    var _a;
                    if ((_a = item === null || item === void 0 ? void 0 : item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) {
                        emailArr.push(item.contactItem.contactItemVal);
                    }
                });
            }
            return [
                {
                    code: res.errorRcpts,
                    email: (emailArr === null || emailArr === void 0 ? void 0 : emailArr.length) ? emailArr.join(',') : '[未知邮箱]',
                    reason: this.mailRecptErrMap[res.errorRcpts],
                },
            ];
        }
        return undefined;
    }
    buildMailSendRequest(params) {
        var _a, _b, _c, _d, _e, _f;
        const { operation, auto, purpose, pureText, attrObj, noCheckAtt } = params;
        const { content } = params;
        console.log('[mail-send] build send mail:', content, operation);
        const attatchment = [];
        const cloudattachments = [];
        const contactReq = this.buildToContactReq(content);
        const user = this.systemApi.getCurrentUser(content._account);
        if (!user) {
            this.eventApi.sendSimpleSysEvent('logout');
            throw new Error('not login , why?');
        }
        let finalAccount = '';
        const { aliasSender } = content;
        const aliasSenderName = (aliasSender === null || aliasSender === void 0 ? void 0 : aliasSender.nickName) || (aliasSender === null || aliasSender === void 0 ? void 0 : aliasSender.name);
        if (content._account) {
            if (aliasSender && aliasSender.mailEmail === content._account) {
                finalAccount = this.buildEmailStr(aliasSender === null || aliasSender === void 0 ? void 0 : aliasSender.id, aliasSenderName);
            }
            else {
                finalAccount = this.buildEmailStr(content._account);
            }
        }
        else {
            finalAccount = aliasSender ? this.buildEmailStr(aliasSender.id, aliasSenderName) : this.buildEmailStr(user.id, user.nickName);
        }
        if (purpose === 'deleteAtt' && attrObj) {
            return {
                id: content._id,
                action: 'continue',
                attrs: {
                    attachments: [{ id: attrObj.id, deleted: true }],
                    account: finalAccount,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        if (purpose === 'addAtt' && attrObj) {
            return {
                id: content._id,
                action: 'continue',
                attrs: {
                    attachments: [
                        {
                            id: attrObj.id,
                            deleted: false,
                            inlined: ((_a = attrObj.attachment) === null || _a === void 0 ? void 0 : _a.type) === 'internal',
                        },
                    ],
                    account: finalAccount,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        if (purpose === 'rename' && attrObj) {
            const { attachment } = attrObj;
            const { type, name, fileName } = attachment || {};
            console.log('attachmentattachment', attachment);
            const newName = name || fileName;
            return {
                id: content._id,
                action: 'continue',
                attrs: {
                    attachments: [
                        Object.assign({ id: attrObj.id }, (type === 'netUrl'
                            ? {
                                displayName: newName,
                                type: 'url',
                            }
                            : { name: newName })),
                    ],
                    account: finalAccount,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        if (purpose === 'sendCheck') {
            return {
                id: content._id,
                action: 'continue',
                attrs: {
                    account: finalAccount,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        if (purpose === 'resetSaveDraft') {
            return {
                id: content._id,
                action: 'save',
                attrs: {
                    account: finalAccount,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        const conf = new Map([['mailModel', content]]);
        const someCloudAttach = (_b = content.entry.attachment) === null || _b === void 0 ? void 0 : _b.some(attach => attach.cloudIdentity);
        const needHtml = pureText !== true || someCloudAttach;
        content.entry.content.content = this.modelHandler.getTransferHtml(content.entry.content, 'sendMail', needHtml, conf);
        console.log('[mail-send] got mail content conf : ', conf);
        if (content.entry.attachment && content.entry.attachment.length > 0) {
            Object.keys(conf).forEach(it => {
                var _a, _b;
                if (it.startsWith('img-')) {
                    const url = conf.get(it);
                    const composeId = (_a = new URL(url).searchParams) === null || _a === void 0 ? void 0 : _a.get('composeId');
                    if (composeId !== content._id && content._id !== undefined) {
                        const find = (_b = content.entry.attachment) === null || _b === void 0 ? void 0 : _b.find(att => 'img-' + att.id === it);
                        if (find) {
                            this.eventApi.sendSysEvent({
                                eventName: 'error',
                                eventLevel: 'error',
                                eventStrData: '',
                                eventData: {
                                    popupType: 'toast',
                                    popupLevel: 'info',
                                    title: getIn18Text('FUJIAN：') + find.fileName + getIn18Text('KENENGCUNZAISHANGCHUANCUO'),
                                    content: '',
                                    code: 'PARAM.ERR',
                                },
                                eventSeq: 0,
                            });
                        }
                    }
                }
            });
            content.entry.attachment.forEach(it => {
                if (it.id && (it.inlined || (it.fromServer && it.type === 'internal'))) {
                    if (!conf.get('img-' + it.id)) {
                        it.deleted = true;
                    }
                    else {
                        it.deleted = false;
                    }
                }
            });
            !noCheckAtt &&
                content.entry.attachment.forEach(it => {
                    if (!it.deleted && !it.ready) {
                        this.loggerApi.track('write_mail_param_not_all_attachment_uploaded', content);
                        this.dataTrackApi.track('write_mail_param_not_all_attachment_uploaded', { attId: it.id });
                        this.eventApi.sendSysEvent({
                            eventSeq: 0,
                            eventName: 'error',
                            eventLevel: 'error',
                            eventStrData: '',
                            eventData: {
                                popupType: 'window',
                                popupLevel: 'error',
                                title: getIn18Text('TISHI'),
                                content: getIn18Text('FUJIAN') + it.fileName + getIn18Text('WEISHANGCHUANWANCHENG，QING'),
                                code: 'attachment_upload_uncompleted',
                            },
                            auto: true,
                        });
                        throw new Error('not completed');
                    }
                });
            this.buildAttachmentReq(content, attatchment, cloudattachments, operation, auto, purpose);
        }
        if (purpose === 'forcesave') {
            return {
                id: content._id,
                action: 'save',
                attrs: {
                    account: finalAccount,
                    content: content.entry.content.content,
                },
                delayTime: 0,
                mailTrace: false,
                returnInfo: true,
                xMailerExt,
            };
        }
        let to = contactReq.to && contactReq.to.length > 0 ? contactReq.to.map(item => item.emailStr) : [];
        let cc = contactReq.cc && contactReq.cc.length > 0 ? contactReq.cc.map(item => item.emailStr) : [];
        let bcc = contactReq.bcc && contactReq.bcc.length > 0 ? contactReq.bcc.map(item => item.emailStr) : [];
        if (content.isOneRcpt) {
            to = to.concat(cc, bcc);
            cc = [];
            bcc = [];
        }
        let noticeSenderReceivers = [];
        if (content.senderReceivers) {
            let noticeOuterDomain = false;
            if (this.productAuthApi.doGetProductVersionId() === 'sirius') {
                noticeOuterDomain = true;
            }
            if (!noticeOuterDomain) {
                const domainList = lodashGet(this.systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account), 'prop.domainList', []);
                [...(((_c = contactReq === null || contactReq === void 0 ? void 0 : contactReq.to) === null || _c === void 0 ? void 0 : _c.length) ? contactReq.to : []), ...(((_d = contactReq === null || contactReq === void 0 ? void 0 : contactReq.cc) === null || _d === void 0 ? void 0 : _d.length) ? contactReq.cc : []), ...(((_e = contactReq === null || contactReq === void 0 ? void 0 : contactReq.bcc) === null || _e === void 0 ? void 0 : _e.length) ? contactReq.bcc : [])].forEach(item => {
                    const { email, emailStr } = item;
                    const suffix = email.split('@')[1];
                    if (suffix && domainList.includes(suffix)) {
                        noticeSenderReceivers.push(emailStr);
                    }
                });
            }
            else {
                noticeSenderReceivers = to.concat(cc, bcc);
            }
        }
        let delayTime = 0;
        if (operation === 'deliver') {
            const sendRevokeRes = this.storeApi.getSync('sendRevoke');
            if (!!sendRevokeRes.suc && sendRevokeRes.data === 'ON') {
                const sendRevokeInRes = this.storeApi.getSync('sendRevokeIn');
                if (!!sendRevokeInRes && sendRevokeInRes.data) {
                    delayTime = Number(sendRevokeInRes.data);
                }
            }
        }
        let scheduleDate;
        let clientTimeZone;
        if (operation === 'schedule') {
            scheduleDate = content === null || content === void 0 ? void 0 : content.scheduleDate;
            clientTimeZone = content === null || content === void 0 ? void 0 : content.scheduleDateTimeZone;
        }
        let mailTrace = false;
        let riskHitIntercept = false;
        if (operation && ['deliver', 'schedule'].includes(operation)) {
            riskHitIntercept = true;
            if (this.productAuthApi.doGetProductVersionId() === 'sirius') {
                mailTrace = true;
                const stateTrack = this.storeApi.getSync('stateTrack').data;
                if (stateTrack === 'OFF') {
                    mailTrace = false;
                }
            }
        }
        const compose = Object.assign(Object.assign({ delayTime, returnInfo: true, action: operation, mailTrace }, (clientTimeZone ? { clientTimeZone } : {})), { attrs: {
                subject: content.entry.title,
                requestReadReceipt: content.requestReadReceipt,
                to,
                cc,
                bcc,
                content: content.entry.content.content,
                attachments: attatchment,
                cloudattachments,
                account: finalAccount,
                isHtml: !pureText || someCloudAttach,
                saveSentCopy: true,
                showOneRcpt: content.isOneRcpt,
                scheduleDate,
            }, noticeSenderReceivers,
            riskHitIntercept,
            xMailerExt, id: content._id });
        if ((_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.priority) {
            compose.attrs.priority = content.entry.priority;
        }
        if (content === null || content === void 0 ? void 0 : content.setEncrypt) {
            compose.encryptPassword = content.entry.encpwd;
            compose.savePassword = content.savePassword || false;
        }
        let ret;
        if (content.praiseLetter) {
            ret = {
                compose,
                praiseLetter: content.praiseLetter,
                id: content._id,
            };
        }
        else if (content.task) {
            const fromMap = {
                common: 'empty',
                reply: 'reply',
                replyAll: 'reply',
                replyWithAttach: 'reply',
                replyAllWithAttach: 'reply',
                forward: 'forward',
                editDraft: 'draft',
                edit: 'draft',
                forwardAsAttach: 'empty',
            };
            let from = 'empty';
            if (content.entry.writeLetterProp) {
                from = fromMap[content.entry.writeLetterProp];
            }
            ret = {
                compose,
                task: content.task,
                from,
            };
        }
        else {
            ret = compose;
        }
        if (content.resend) {
            delete ret.id;
        }
        this.loggerApi.track('write_mail_param', {
            subject: content.entry.title,
            requestReadReceipt: content.requestReadReceipt,
            to,
            cc,
            bcc,
            content: content.entry.content.content.length,
            attachments: attatchment.length,
            account: finalAccount,
            isHtml: !pureText || someCloudAttach,
            saveSentCopy: true,
            showOneRcpt: content.isOneRcpt,
            scheduleDate,
        });
        return ret;
    }
    buildToContactReq(content) {
        const { receiver } = content;
        const ret = {};
        receiver.forEach(it => {
            const element = it.mailMemberType || 'to';
            let list = ret[element];
            if (!list) {
                list = [];
            }
            const email = it.contactItem.contactItemVal;
            const name = it.contact.contact.contactName;
            const emailStr = this.buildEmailStr(email, name);
            list.push({ email, name, emailStr });
            ret[element] = list;
        });
        return ret;
    }
    buildFilterAttachment(req) {
        var _a;
        const { attrs } = req;
        const { content } = req.attrs;
        const attachIdList = [];
        content === null || content === void 0 ? void 0 : content.replace(/attachId=([0-9]+)/g, (_, p1) => {
            attachIdList.push(parseInt(p1, 10));
            return '';
        });
        attrs.attachments = (_a = attrs.attachments) === null || _a === void 0 ? void 0 : _a.map(it => {
            if (it.inlined && it.id && attachIdList.indexOf(it.id) === -1) {
                it.deleted = true;
            }
            return it;
        });
    }
    buildEmailStr(email, name) {
        if (!email) {
            return '';
        }
        return name ? `"${name}" <${email}>` : email;
    }
    doMailAttachmentCheckFull(_attachments, content) {
        var _a;
        const localAttachments = ((_a = content.entry) === null || _a === void 0 ? void 0 : _a.attachment) || [];
        let checkPass = true;
        console.log('doMailAttachmentCheckFull before', localAttachments, _attachments);
        localAttachments.forEach(it => {
            var _a;
            const ckRes = { attachmentId: it.id, name: it.name };
            if (it.type !== 'trs' && it.type !== 'netfolder') {
                const attFromServer = (_a = (_attachments || [])) === null || _a === void 0 ? void 0 : _a.find(item => item.id == it.id);
                if (!attFromServer) {
                    checkPass = false;
                    it.mailCheckResult = Object.assign(Object.assign({}, ckRes), { pass: false, failReason: getIn18Text('FUWUQIWEIBAOCUNGAI') });
                }
                else if (it.deleted && !attFromServer.deleted) {
                    checkPass = false;
                    it.mailCheckResult = Object.assign(Object.assign({}, ckRes), { pass: false, failReason: getIn18Text('BENDESHANCHUYUANDUANWEI') });
                }
                else if (!it.deleted && attFromServer.deleted) {
                    checkPass = false;
                    it.mailCheckResult = Object.assign(Object.assign({}, ckRes), { pass: false, failReason: getIn18Text('BENDEWEISHANCHUYUANDUAN') });
                }
                else {
                    it.mailCheckResult = Object.assign(Object.assign({}, ckRes), { pass: true });
                }
            }
            else {
                it.mailCheckResult = Object.assign(Object.assign({}, ckRes), { pass: true });
            }
        });
        (_attachments || []).forEach(it => {
            const { id } = it;
            const localAtt = (localAttachments || []).find(item => item.id == id);
            if (!localAtt) {
                checkPass = false;
            }
        });
        if (!checkPass) {
            this.loggerApi.track('send_mail_check_fail', { local: localAttachments, remote: _attachments });
        }
        console.log('doMailAttachmentCheckFull after', localAttachments, checkPass);
        return checkPass;
    }
}
MailSendHandler.mailAttachmentUploadHost = config('mailAttachmentUploadHost');
